var _style;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgResult(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "animated",
    viewBox: "0 0 500 500",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "svg#freepik_stories-business-analytics:not(.animated) .animable {opacity: 0;}svg#freepik_stories-business-analytics.animated #freepik--chart-3--inject-43 {animation: 6s Infinite  linear floating;animation-delay: 0s;}svg#freepik_stories-business-analytics.animated #freepik--chart-2--inject-43 {animation: 6s Infinite  linear floating;animation-delay: 0s;}svg#freepik_stories-business-analytics.animated #freepik--chart-1--inject-43 {animation: 6s Infinite  linear floating;animation-delay: 0s;}svg#freepik_stories-business-analytics.animated #freepik--Icon--inject-43 {animation: 6s Infinite  linear floating;animation-delay: 0s;}svg#freepik_stories-business-analytics.animated #freepik--Arrows--inject-43 {animation: 6s Infinite  linear floating;animation-delay: 0s;}            @keyframes floating {                0% {                    opacity: 1;                    transform: translateY(0px);                }                50% {                    transform: translateY(-10px);                }                100% {                    opacity: 1;                    transform: translateY(0px);                }            }        .animator-hidden { display: none; }")), /*#__PURE__*/React.createElement("g", {
    className: "animable animator-hidden",
    style: {
      transformOrigin: "250px 343.69px"
    }
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "animable",
    cx: 250,
    cy: 343.69,
    rx: 238.85,
    ry: 147.47,
    fill: "#f5f5f5",
    style: {
      transformOrigin: "250px 343.69px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    fill: "#e6e6e6",
    style: {
      transformOrigin: "367.075px 368.925px"
    }
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "animable",
    cx: 412.88,
    cy: 315.95,
    rx: 51.59,
    ry: 29.79,
    style: {
      transformOrigin: "412.88px 315.95px"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "animable",
    cx: 329.71,
    cy: 417.03,
    rx: 60.03,
    ry: 34.66,
    style: {
      transformOrigin: "329.71px 417.03px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "174.316px 202.788px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "b",
    className: "animable",
    style: {
      transformOrigin: "100.121px 68.6015px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M75,100.62a1.55,1.55,0,0,1-.31,0l-3.09-.48a1.7,1.7,0,0,1-1.4-2.21l1.69-5.71A1.3,1.3,0,0,0,71.45,91a10.88,10.88,0,0,1-.92-1,.5.5,0,0,0-.7-.14L66,92.8A1.41,1.41,0,0,1,63.65,92l-1-4.37a3.12,3.12,0,0,1,.71-2.67l3.8-4a3,3,0,0,0,.67-1.63,30.41,30.41,0,0,1,.32-3,.8.8,0,0,0-.47-.83l-2.44-.86a1.84,1.84,0,0,1-1.07-1,1.81,1.81,0,0,1-.06-1.44l2.35-6.37a2.55,2.55,0,0,1,2.25-1.6l2.94,0a1.68,1.68,0,0,0,1.22-.73c.62-1.05,1.28-2.06,2-3a2.69,2.69,0,0,0,.44-1.66l-.55-4.32a3.2,3.2,0,0,1,1-2.6L80,48a1.44,1.44,0,0,1,2.41.59l1.26,3.35a.33.33,0,0,0,.19.22.44.44,0,0,0,.35,0,16.12,16.12,0,0,1,1.92-.78,2.32,2.32,0,0,0,1.23-1l2.51-5.65a2.33,2.33,0,0,1,2.4-1.31l3.1.47A1.71,1.71,0,0,1,96.73,46L95,51.7a1.32,1.32,0,0,0,.41,1.19,7.87,7.87,0,0,1,.92,1,.5.5,0,0,0,.7.14l3.87-2.93a1.41,1.41,0,0,1,2.32.83l1,4.36a3.14,3.14,0,0,1-.72,2.68l-3.8,4a3.09,3.09,0,0,0-.67,1.63,25,25,0,0,1-.32,3.06.8.8,0,0,0,.48.83l2.43.85a1.86,1.86,0,0,1,1.14,2.41l-2.35,6.37a2.56,2.56,0,0,1-2.25,1.6l-3,0a1.68,1.68,0,0,0-1.21.73c-.62,1-1.28,2-2,3a2.83,2.83,0,0,0-.44,1.66l.56,4.32a3.27,3.27,0,0,1-1,2.6l-4.33,3.89a1.45,1.45,0,0,1-2.42-.59L83.27,92a.34.34,0,0,0-.2-.22.44.44,0,0,0-.35,0,15.47,15.47,0,0,1-1.92.78,2.32,2.32,0,0,0-1.23,1l-2.5,5.65A2.38,2.38,0,0,1,75,100.62ZM70.1,88.4a1.93,1.93,0,0,1,1.5.75,7.05,7.05,0,0,0,.79.84,2.68,2.68,0,0,1,.79,2.59L71.49,98.3a.34.34,0,0,0,0,.3.38.38,0,0,0,.27.16l3.09.48a1,1,0,0,0,.94-.52l2.51-5.65a3.65,3.65,0,0,1,2.06-1.79,12.6,12.6,0,0,0,1.75-.71,1.83,1.83,0,0,1,1.45-.07,1.69,1.69,0,0,1,1,1l1.26,3.35c0,.09.07.13.08.13a.34.34,0,0,0,.13-.08L90.35,91a1.91,1.91,0,0,0,.52-1.4l-.56-4.33a4.06,4.06,0,0,1,.7-2.64c.66-.91,1.3-1.88,1.89-2.89a3.06,3.06,0,0,1,2.38-1.4l2.94-.05a1.21,1.21,0,0,0,1-.7l2.35-6.37a.49.49,0,0,0-.3-.64l-2.44-.85a2.17,2.17,0,0,1-1.37-2.34,26.84,26.84,0,0,0,.3-2.91,4.33,4.33,0,0,1,1-2.51l3.8-4a1.73,1.73,0,0,0,.37-1.4h0l-1-4.37c0-.07,0-.11,0-.12a.71.71,0,0,0-.11.07L97.9,55.11a1.85,1.85,0,0,1-2.6-.37,6.93,6.93,0,0,0-.78-.84,2.67,2.67,0,0,1-.79-2.59l1.69-5.72a.38.38,0,0,0,0-.3.34.34,0,0,0-.27-.16L92,44.65a1,1,0,0,0-.94.52l-2.5,5.64a3.7,3.7,0,0,1-2.06,1.8,12.77,12.77,0,0,0-1.75.7,1.78,1.78,0,0,1-1.46.08,1.72,1.72,0,0,1-1-1L81.1,49c0-.09-.08-.13-.09-.13a.33.33,0,0,0-.13.08l-4.33,3.89a1.9,1.9,0,0,0-.51,1.4l.56,4.33a4.19,4.19,0,0,1-.7,2.64c-.67.91-1.3,1.88-1.9,2.89a3,3,0,0,1-2.38,1.4l-2.94,0a1.2,1.2,0,0,0-1,.7l-2.36,6.37a.5.5,0,0,0,0,.38.53.53,0,0,0,.29.26l2.43.85a2.18,2.18,0,0,1,1.38,2.34,27.44,27.44,0,0,0-.31,2.91,4.39,4.39,0,0,1-1,2.51l-3.8,4a1.77,1.77,0,0,0-.38,1.4L65,91.65a.52.52,0,0,0,0,.12.71.71,0,0,0,.11-.07L69,88.77A1.79,1.79,0,0,1,70.1,88.4Zm9.7-3.73a5.54,5.54,0,0,1-1.63-.24c-1.92-.6-3.29-2.26-3.88-4.69C73,74.39,75.9,66.49,80.75,62.13c2.7-2.43,5.61-3.41,8-2.67a6,6,0,0,1,3.88,4.69C93.9,69.5,91,77.4,86.15,81.76h0A9.9,9.9,0,0,1,79.8,84.67Zm7.3-24.08a8.58,8.58,0,0,0-5.43,2.56c-4.52,4.06-7.23,11.36-6,16.27.48,2,1.5,3.25,3,3.7,1.9.58,4.32-.28,6.66-2.38,4.51-4.06,7.22-11.36,6-16.27-.47-2-1.5-3.25-3-3.7A4.14,4.14,0,0,0,87.1,60.59Z",
    style: {
      transformOrigin: "83.4341px 72.0144px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M118,74.65h-.22l-2.05-.32a1.28,1.28,0,0,1-.88-.57,1.3,1.3,0,0,1-.14-1l1.13-3.79a.81.81,0,0,0-.24-.68,8,8,0,0,1-.63-.67c0-.07-.19-.17-.31-.08l-2.57,2a1.09,1.09,0,0,1-1,.19,1.07,1.07,0,0,1-.68-.8l-.7-2.9a2.19,2.19,0,0,1,.51-1.88l2.52-2.64a1.93,1.93,0,0,0,.41-1,18.4,18.4,0,0,1,.22-2,.42.42,0,0,0-.25-.43l-1.62-.57a1.35,1.35,0,0,1-.82-1.74l1.57-4.23a1.8,1.8,0,0,1,1.59-1.13l2,0a1,1,0,0,0,.72-.43,23,23,0,0,1,1.32-2,1.74,1.74,0,0,0,.27-1l-.37-2.87a2.29,2.29,0,0,1,.67-1.82l2.88-2.58a1.09,1.09,0,0,1,1-.29,1.13,1.13,0,0,1,.77.72l.83,2.23c.11.1.16.09.21.06a11.23,11.23,0,0,1,1.29-.52,1.43,1.43,0,0,0,.75-.63l1.67-3.75a1.64,1.64,0,0,1,1.71-.94l2.06.32a1.24,1.24,0,0,1,1,1.6l-1.12,3.8a.76.76,0,0,0,.24.68,5,5,0,0,1,.62.67.23.23,0,0,0,.32.07l2.56-1.94a1.12,1.12,0,0,1,1-.2,1.13,1.13,0,0,1,.68.81l.69,2.9a2.17,2.17,0,0,1-.5,1.87l-2.52,2.65a2,2,0,0,0-.42,1,18.76,18.76,0,0,1-.21,2,.42.42,0,0,0,.24.43l1.62.56a1.38,1.38,0,0,1,.78.7,1.34,1.34,0,0,1,0,1l-1.56,4.23a1.79,1.79,0,0,1-1.59,1.13l-2,0a1,1,0,0,0-.72.43c-.4.69-.85,1.36-1.31,2a1.74,1.74,0,0,0-.28,1l.37,2.88a2.26,2.26,0,0,1-.67,1.81L126,71.52a1.06,1.06,0,0,1-1.78-.44l-.84-2.22c-.11-.1-.16-.09-.21-.07a10,10,0,0,1-1.29.53,1.39,1.39,0,0,0-.75.63L119.5,73.7A1.67,1.67,0,0,1,118,74.65Zm-3.23-8.33a1.39,1.39,0,0,1,1.08.54,5.35,5.35,0,0,0,.51.55,1.89,1.89,0,0,1,.56,1.83L115.8,73l.11.17,2,.32a.52.52,0,0,0,.51-.28l1.67-3.75a2.55,2.55,0,0,1,1.43-1.25,8.35,8.35,0,0,0,1.15-.46,1.26,1.26,0,0,1,1.76.68l.83,2.23,2.85-2.59a1.23,1.23,0,0,0,.31-.84l-.38-2.87a2.85,2.85,0,0,1,.49-1.83c.44-.61.86-1.25,1.25-1.91a2.14,2.14,0,0,1,1.67-1l2,0a.72.72,0,0,0,.55-.39L135.57,55a.24.24,0,0,0,0-.17.25.25,0,0,0-.13-.11l-1.62-.57a1.53,1.53,0,0,1-1-1.67,18.68,18.68,0,0,0,.2-1.92,3.09,3.09,0,0,1,.72-1.74l2.52-2.65a1,1,0,0,0,.23-.83h0l-.7-2.9-2.5,2a1.34,1.34,0,0,1-1.88-.27,6.52,6.52,0,0,0-.5-.54,1.87,1.87,0,0,1-.56-1.83l1.12-3.8,0-.14-.14,0-2-.32a.52.52,0,0,0-.51.28l-1.66,3.75a2.57,2.57,0,0,1-1.44,1.25,10.73,10.73,0,0,0-1.15.47,1.33,1.33,0,0,1-1,.05,1.2,1.2,0,0,1-.7-.74L122,40.32l-2.84,2.59a1.16,1.16,0,0,0-.31.83l.37,2.88a2.86,2.86,0,0,1-.48,1.83,22.5,22.5,0,0,0-1.26,1.91,2.16,2.16,0,0,1-1.67,1l-2,0a.72.72,0,0,0-.56.39L111.72,56a.19.19,0,0,0,0,.17.22.22,0,0,0,.13.12l1.62.57a1.55,1.55,0,0,1,1,1.67,16.26,16.26,0,0,0-.2,1.92,3,3,0,0,1-.73,1.73L111,64.83a1.08,1.08,0,0,0-.22.83l.69,2.9,2.51-2A1.3,1.3,0,0,1,114.78,66.32Zm6.44-2.26a3.73,3.73,0,0,1-1.11-.16,4.11,4.11,0,0,1-2.65-3.19c-.87-3.59,1.07-8.89,4.32-11.81,1.82-1.64,3.79-2.29,5.4-1.79a4.1,4.1,0,0,1,2.66,3.19c.86,3.59-1.08,8.88-4.33,11.8h0A6.67,6.67,0,0,1,121.22,64.06Zm4.85-16a5.58,5.58,0,0,0-3.53,1.67c-3,2.67-4.77,7.48-4,10.7a3,3,0,0,0,1.89,2.38c1.22.38,2.8-.19,4.32-1.56h0c3-2.67,4.76-7.47,4-10.7a3,3,0,0,0-1.89-2.37A2.54,2.54,0,0,0,126.07,48.07Z",
    style: {
      transformOrigin: "123.661px 55.6126px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    style: {
      transformOrigin: "247.686px 337.426px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M256.57,363.14l-.3,0-3.09-.48a1.7,1.7,0,0,1-1.4-2.21l1.69-5.71a1.37,1.37,0,0,0-.41-1.2,8.53,8.53,0,0,1-.92-1,.51.51,0,0,0-.7-.15l-3.87,2.93a1.41,1.41,0,0,1-2.32-.83l-1.05-4.36a3.13,3.13,0,0,1,.72-2.67l3.8-4a3.09,3.09,0,0,0,.67-1.63,25.44,25.44,0,0,1,.32-3.06.81.81,0,0,0-.48-.83l-2.43-.85a1.86,1.86,0,0,1-1.14-2.41l2.35-6.37a2.58,2.58,0,0,1,2.25-1.6l3-.05a1.67,1.67,0,0,0,1.21-.72c.62-1.05,1.29-2.06,2-3a2.8,2.8,0,0,0,.44-1.65l-.56-4.33a3.25,3.25,0,0,1,1-2.59l4.33-3.89a1.53,1.53,0,0,1,1.38-.4,1.51,1.51,0,0,1,1,1l1.25,3.35a.4.4,0,0,0,.2.22.41.41,0,0,0,.35,0,14,14,0,0,1,1.92-.77,2.38,2.38,0,0,0,1.23-1.05l2.5-5.64a2.35,2.35,0,0,1,2.41-1.32l3.09.48a1.7,1.7,0,0,1,1.4,2.21l-1.69,5.71a1.34,1.34,0,0,0,.4,1.2,9.6,9.6,0,0,1,.93,1,.49.49,0,0,0,.7.15l3.86-2.93a1.41,1.41,0,0,1,2.32.83l1.05,4.36a3.09,3.09,0,0,1-.71,2.67l-3.8,4a3,3,0,0,0-.67,1.63,29.7,29.7,0,0,1-.32,3.06.81.81,0,0,0,.47.83l2.44.85a1.83,1.83,0,0,1,1.07,1,1.8,1.8,0,0,1,.06,1.44l-2.35,6.37a2.57,2.57,0,0,1-2.25,1.6l-2.94,0a1.67,1.67,0,0,0-1.22.72,35.47,35.47,0,0,1-2,3,2.66,2.66,0,0,0-.44,1.65l.56,4.33a3.22,3.22,0,0,1-1,2.59l-4.32,3.89a1.5,1.5,0,0,1-1.38.4,1.53,1.53,0,0,1-1-1l-1.26-3.35a.35.35,0,0,0-.19-.22.4.4,0,0,0-.35,0,14.51,14.51,0,0,1-1.92.77,2.34,2.34,0,0,0-1.23,1.05l-2.51,5.64A2.35,2.35,0,0,1,256.57,363.14Zm-4.86-12.21a1.92,1.92,0,0,1,1.5.75,7.72,7.72,0,0,0,.78.83,2.71,2.71,0,0,1,.79,2.6l-1.69,5.71a.41.41,0,0,0,0,.31.33.33,0,0,0,.26.15l3.1.48a1,1,0,0,0,.94-.51l2.5-5.65a3.68,3.68,0,0,1,2.06-1.79,14.27,14.27,0,0,0,1.75-.71,1.78,1.78,0,0,1,1.46-.07,1.73,1.73,0,0,1,1,1l1.25,3.35a.44.44,0,0,0,.09.14.52.52,0,0,0,.13-.09l4.33-3.89a1.89,1.89,0,0,0,.51-1.4l-.56-4.32a4.17,4.17,0,0,1,.7-2.64c.67-.92,1.31-1.89,1.9-2.89a3.06,3.06,0,0,1,2.38-1.41l2.94-.05a1.21,1.21,0,0,0,1-.7l2.35-6.37a.5.5,0,0,0,0-.38.55.55,0,0,0-.28-.26l-2.44-.85a2.17,2.17,0,0,1-1.38-2.34,26.9,26.9,0,0,0,.31-2.91,4.33,4.33,0,0,1,1.05-2.51l3.79-4a1.8,1.8,0,0,0,.38-1.41h0l-1.05-4.36a.7.7,0,0,0,0-.13l-.11.07-3.87,2.93a1.84,1.84,0,0,1-2.59-.38,7.72,7.72,0,0,0-.78-.83,2.69,2.69,0,0,1-.8-2.6l1.69-5.71a.32.32,0,0,0-.29-.46l-3.09-.48a1,1,0,0,0-.94.51l-2.51,5.65a3.65,3.65,0,0,1-2.06,1.79,15.68,15.68,0,0,0-1.75.71,1.75,1.75,0,0,1-1.45.07,1.73,1.73,0,0,1-1-1l-1.26-3.35a.34.34,0,0,0-.08-.14.3.3,0,0,0-.13.09l-4.33,3.89a1.89,1.89,0,0,0-.52,1.39l.56,4.33a4,4,0,0,1-.7,2.64,33.66,33.66,0,0,0-1.89,2.9,3.09,3.09,0,0,1-2.38,1.4l-2.94.05a1.2,1.2,0,0,0-1,.69L247,335.17a.5.5,0,0,0,0,.38.53.53,0,0,0,.29.26l2.44.85a2.15,2.15,0,0,1,1.37,2.33,25.38,25.38,0,0,0-.3,2.92,4.33,4.33,0,0,1-1,2.51l-3.8,4a1.76,1.76,0,0,0-.37,1.41l1.05,4.36a.34.34,0,0,0,0,.13l.11-.07,3.86-2.93A1.82,1.82,0,0,1,251.71,350.93Zm9.69-3.74a5.47,5.47,0,0,1-1.62-.23,6,6,0,0,1-3.88-4.69c-1.29-5.35,1.6-13.25,6.46-17.61,2.7-2.44,5.61-3.41,8-2.68,1.92.6,3.29,2.26,3.88,4.69,1.29,5.35-1.61,13.25-6.46,17.62h0A9.89,9.89,0,0,1,261.4,347.19Zm7.3-24.07a8.6,8.6,0,0,0-5.43,2.56c-4.51,4.06-7.22,11.36-6,16.27a4.64,4.64,0,0,0,3,3.69c1.89.59,4.32-.28,6.65-2.37,4.52-4.07,7.23-11.37,6.05-16.28-.48-2-1.5-3.24-3-3.69A3.86,3.86,0,0,0,268.7,323.12Z",
    style: {
      transformOrigin: "265.093px 334.496px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M217.66,369h-.22l-2.05-.32a1.25,1.25,0,0,1-.88-.57,1.22,1.22,0,0,1-.14-1l1.13-3.79a.81.81,0,0,0-.24-.68,8,8,0,0,1-.63-.67c-.06-.07-.19-.17-.31-.08l-2.57,1.95a1.09,1.09,0,0,1-1,.19,1.07,1.07,0,0,1-.68-.8l-.7-2.9a2.22,2.22,0,0,1,.5-1.88l2.53-2.64a2,2,0,0,0,.41-1,16.28,16.28,0,0,1,.22-2,.42.42,0,0,0-.25-.43l-1.62-.57a1.34,1.34,0,0,1-.77-.69,1.37,1.37,0,0,1-.05-1.05l1.57-4.23a1.8,1.8,0,0,1,1.59-1.13l1.95,0a1,1,0,0,0,.72-.43,23,23,0,0,1,1.32-2,1.74,1.74,0,0,0,.27-1l-.37-2.87a2.29,2.29,0,0,1,.67-1.82l2.88-2.58a1.12,1.12,0,0,1,1-.29,1.13,1.13,0,0,1,.77.72l.83,2.23c.11.1.16.09.21.06a11.23,11.23,0,0,1,1.29-.52,1.43,1.43,0,0,0,.75-.63l1.67-3.75a1.65,1.65,0,0,1,1.71-.94l2.06.32a1.27,1.27,0,0,1,.88.57,1.24,1.24,0,0,1,.13,1l-1.12,3.8a.76.76,0,0,0,.24.68,6.64,6.64,0,0,1,.62.67.23.23,0,0,0,.32.07l2.56-1.94a1.12,1.12,0,0,1,1-.2,1.1,1.1,0,0,1,.67.81l.7,2.9a2.19,2.19,0,0,1-.5,1.87L234.23,344a1.87,1.87,0,0,0-.42,1,18.51,18.51,0,0,1-.21,2.05.42.42,0,0,0,.24.43l1.62.56a1.38,1.38,0,0,1,.78.7,1.34,1.34,0,0,1,0,1L234.72,354a1.83,1.83,0,0,1-1.6,1.13l-2,0a1,1,0,0,0-.72.43c-.41.69-.85,1.36-1.31,2a1.74,1.74,0,0,0-.28,1l.37,2.88a2.25,2.25,0,0,1-.67,1.81l-2.87,2.59a1.13,1.13,0,0,1-1,.29,1.11,1.11,0,0,1-.76-.73l-.84-2.22c-.11-.1-.16-.09-.21-.07a10,10,0,0,1-1.29.53,1.39,1.39,0,0,0-.75.63l-1.67,3.75A1.65,1.65,0,0,1,217.66,369Zm-3.23-8.32a1.38,1.38,0,0,1,1.08.53,5.35,5.35,0,0,0,.51.55,1.92,1.92,0,0,1,.56,1.83l-1.13,3.79.11.17,2.05.32a.53.53,0,0,0,.51-.27l1.67-3.76a2.55,2.55,0,0,1,1.43-1.25,8.35,8.35,0,0,0,1.15-.46,1.26,1.26,0,0,1,1.76.68l.83,2.23,2.85-2.59a1.18,1.18,0,0,0,.3-.84l-.37-2.87a2.85,2.85,0,0,1,.49-1.83c.44-.61.86-1.25,1.25-1.91a2.12,2.12,0,0,1,1.67-1l2,0a.72.72,0,0,0,.55-.39l1.56-4.24a.24.24,0,0,0,0-.17.3.3,0,0,0-.13-.11l-1.62-.57a1.53,1.53,0,0,1-1-1.67,18.68,18.68,0,0,0,.2-1.92,3,3,0,0,1,.72-1.74l2.52-2.65a1.08,1.08,0,0,0,.23-.83h0l-.7-2.9-2.5,2a1.34,1.34,0,0,1-1.88-.26,4.49,4.49,0,0,0-.51-.55,1.89,1.89,0,0,1-.55-1.83l1.12-3.8,0-.14-.14,0-2.05-.32a.52.52,0,0,0-.51.28l-1.67,3.75a2.52,2.52,0,0,1-1.43,1.25,10.73,10.73,0,0,0-1.15.47,1.33,1.33,0,0,1-1.05.05,1.2,1.2,0,0,1-.7-.74l-.84-2.22-2.84,2.59a1.16,1.16,0,0,0-.31.83l.37,2.88a2.92,2.92,0,0,1-.48,1.83,22.5,22.5,0,0,0-1.26,1.91,2.13,2.13,0,0,1-1.67,1l-1.95,0a.72.72,0,0,0-.56.39l-1.56,4.23a.19.19,0,0,0,0,.17.22.22,0,0,0,.13.12l1.62.57a1.55,1.55,0,0,1,1,1.67,16.26,16.26,0,0,0-.2,1.92,3,3,0,0,1-.73,1.73l-2.52,2.65a1.13,1.13,0,0,0-.23.83l.7,2.9,2.51-2A1.29,1.29,0,0,1,214.43,360.72Zm6.44-2.27a3.68,3.68,0,0,1-1.11-.16,4.09,4.09,0,0,1-2.65-3.19c-.87-3.59,1.07-8.89,4.32-11.8,1.82-1.64,3.79-2.3,5.4-1.8a4.1,4.1,0,0,1,2.66,3.19c.86,3.59-1.08,8.88-4.33,11.8h0A6.67,6.67,0,0,1,220.87,358.45Zm4.84-16a5.62,5.62,0,0,0-3.53,1.67c-3,2.68-4.76,7.48-4,10.7a3,3,0,0,0,1.89,2.38c1.22.38,2.8-.19,4.32-1.56h0c3-2.67,4.76-7.47,4-10.7a3,3,0,0,0-1.89-2.37A2.56,2.56,0,0,0,225.71,342.46Z",
    style: {
      transformOrigin: "223.3px 349.938px"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    style: {
      transformOrigin: "125.881px 160.663px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    className: "animable",
    style: {
      transformOrigin: "125.881px 160.663px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m204.3 51.19a2.35 2.35 0 0 0-1-2.21l-2.66-1.51a2.35 2.35 0 0 0-2.43 0.21l-147.36 85.06a7.48 7.48 0 0 0-3.39 5.87v131.48a2.37 2.37 0 0 0 1 2.2l2.72 1.55a2.38 2.38 0 0 0 2.4-0.24l147.33-85.06a7.5 7.5 0 0 0 3.39-5.87z",
    fill: "#1f1ff9",
    opacity: 0.4,
    style: {
      transformOrigin: "125.881px 160.642px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M204.3,51.2V182.68a7.49,7.49,0,0,1-3.38,5.87L53.58,273.62c-1.66,1-3,.37-3.32-1.29a2.85,2.85,0,0,0,.59-.28L198.18,187a7.48,7.48,0,0,0,3.39-5.87V49.63a3,3,0,0,0-.06-.68C203.1,48.36,204.3,49.27,204.3,51.2Z",
    fill: "#1f1ff9",
    opacity: 0.4,
    style: {
      transformOrigin: "127.28px 161.436px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M200.91,49.24l-11.34,7-30,17.55-36.93,21.4L80.19,119.69l-18.5,10.64L57.07,133l-2.31,1.33c-.37.22-.82.45-1.12.66a6,6,0,0,0-.91.77,7,7,0,0,0-1.94,4.38v5.33l0,53.85-.12,27.28c-.07,28.45-.27,16.61-.44,45.07-.18-28.46-.37-16.62-.44-45.07l-.12-27.28,0-53.85v-5.34a8.13,8.13,0,0,1,2.25-5.19A6.78,6.78,0,0,1,53,134c.44-.29.79-.47,1.18-.7l2.31-1.34,4.62-2.68,18.46-10.69L122,94.07,159,72.8l30.21-17.21Z",
    fill: "#fff",
    style: {
      transformOrigin: "125.29px 160.455px"
    }
  }), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    fill: "#fff",
    opacity: 0.5,
    style: {
      transformOrigin: "125.535px 163.07px"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "73.6 239.5 65.68 244.07 65.68 151.19 73.6 146.61",
    style: {
      transformOrigin: "69.64px 195.34px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "87.57 231.43 79.66 236 79.66 143.12 87.57 138.54",
    style: {
      transformOrigin: "83.615px 187.27px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "101.55 223.36 93.63 227.94 93.63 135.05 101.55 130.48",
    style: {
      transformOrigin: "97.59px 179.21px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "115.52 215.29 107.6 219.87 107.6 126.98 115.52 122.41",
    style: {
      transformOrigin: "111.56px 171.14px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "129.5 207.23 121.58 211.8 121.58 118.91 129.5 114.34",
    style: {
      transformOrigin: "125.54px 163.07px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "143.47 199.16 135.55 203.73 135.55 110.84 143.47 106.27",
    style: {
      transformOrigin: "139.51px 155px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "157.44 191.09 149.53 195.66 149.53 102.78 157.44 98.2",
    style: {
      transformOrigin: "153.485px 146.93px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "171.42 183.02 163.5 187.59 163.5 94.71 171.42 90.14",
    style: {
      transformOrigin: "167.46px 138.865px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "185.39 174.95 177.48 179.53 177.48 86.64 185.39 82.07",
    style: {
      transformOrigin: "181.435px 130.8px"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M73.09,250.07l-6.44,3.72a1.76,1.76,0,0,0-.73,1.4v.15c0,.54.33.79.73.56l6.44-3.72a1.76,1.76,0,0,0,.74-1.41v-.14C73.83,250.09,73.5,249.84,73.09,250.07Z",
    fill: "#455a64",
    style: {
      transformOrigin: "69.875px 252.985px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M87.07,242l-6.44,3.72a1.76,1.76,0,0,0-.73,1.4v.15c0,.54.33.79.73.55l6.44-3.71a1.77,1.77,0,0,0,.74-1.41v-.14C87.81,242,87.48,241.77,87.07,242Z",
    fill: "#455a64",
    style: {
      transformOrigin: "83.855px 244.911px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m101.05 233.93-6.44 3.72a1.76 1.76 0 0 0-0.73 1.4v0.15c0 0.54 0.33 0.79 0.73 0.55l6.44-3.72a1.74 1.74 0 0 0 0.74-1.4v-0.15c0-0.54-0.33-0.79-0.74-0.55z",
    fill: "#455a64",
    style: {
      transformOrigin: "97.835px 236.84px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M115,225.86l-6.44,3.71a1.79,1.79,0,0,0-.73,1.41v.14c0,.54.33.79.73.56L115,228a1.73,1.73,0,0,0,.73-1.4v-.15C115.76,225.87,115.44,225.62,115,225.86Z",
    fill: "#455a64",
    style: {
      transformOrigin: "111.781px 228.767px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M129,217.78l-6.44,3.72a1.78,1.78,0,0,0-.73,1.41v.14c0,.54.33.79.73.56l6.44-3.72a1.76,1.76,0,0,0,.73-1.4v-.15C129.74,217.8,129.41,217.55,129,217.78Z",
    fill: "#455a64",
    style: {
      transformOrigin: "125.78px 220.695px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M143,209.71l-6.44,3.72a1.73,1.73,0,0,0-.73,1.4V215c0,.54.32.79.73.56l6.44-3.72a1.78,1.78,0,0,0,.73-1.41v-.14C143.72,209.73,143.39,209.48,143,209.71Z",
    fill: "#455a64",
    style: {
      transformOrigin: "139.78px 212.635px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M157,201.64l-6.44,3.72a1.74,1.74,0,0,0-.74,1.4v.15c0,.54.33.79.74.55l6.44-3.71a1.79,1.79,0,0,0,.73-1.41v-.14C157.7,201.65,157.37,201.41,157,201.64Z",
    fill: "#455a64",
    style: {
      transformOrigin: "153.775px 204.552px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M171,193.57l-6.44,3.72a1.74,1.74,0,0,0-.74,1.4v.15c0,.54.33.79.74.55l6.44-3.72a1.76,1.76,0,0,0,.73-1.4v-.15C171.68,193.58,171.35,193.33,171,193.57Z",
    fill: "#455a64",
    style: {
      transformOrigin: "167.775px 196.48px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m184.93 185.5-6.44 3.71a1.77 1.77 0 0 0-0.74 1.41v0.14c0 0.54 0.33 0.79 0.74 0.56l6.44-3.72a1.76 1.76 0 0 0 0.73-1.4v-0.15c0-0.54-0.33-0.79-0.73-0.55z",
    fill: "#455a64",
    style: {
      transformOrigin: "181.705px 188.407px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "65.68 223.33 73.6 218.75 73.6 239.5 65.68 244.07",
    fill: "#1f1ff9",
    style: {
      transformOrigin: "69.64px 231.41px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "79.66 193.86 87.57 189.29 87.57 231.43 79.66 236",
    fill: "#1f1ff9",
    style: {
      transformOrigin: "83.615px 212.645px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "93.63 159.12 101.55 154.54 101.55 223.36 93.63 227.94",
    fill: "#1f1ff9",
    style: {
      transformOrigin: "97.59px 191.24px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "107.6 188.31 115.52 183.74 115.52 215.29 107.6 219.87",
    fill: "#1f1ff9",
    style: {
      transformOrigin: "111.56px 201.805px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "121.58 173.23 129.5 168.65 129.5 207.23 121.58 211.8",
    fill: "#1f1ff9",
    style: {
      transformOrigin: "125.54px 190.225px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "135.55 153.24 143.47 148.67 143.47 199.16 135.55 203.73",
    fill: "#1f1ff9",
    style: {
      transformOrigin: "139.51px 176.2px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "149.53 172.32 157.44 167.75 157.44 191.09 149.53 195.66",
    fill: "#1f1ff9",
    style: {
      transformOrigin: "153.485px 181.705px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "163.5 156.81 171.42 152.24 171.42 183.02 163.5 187.59",
    fill: "#1f1ff9",
    style: {
      transformOrigin: "167.46px 169.915px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "177.48 143.8 185.39 139.23 185.39 174.95 177.48 179.53",
    fill: "#1f1ff9",
    style: {
      transformOrigin: "181.435px 159.38px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "65.68 171.47 73.6 166.89 73.6 218.75 65.68 223.33",
    fill: "#1f1ff9",
    style: {
      transformOrigin: "69.64px 195.11px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "79.66 175.19 87.57 170.61 87.57 189.29 79.66 193.86",
    fill: "#1f1ff9",
    style: {
      transformOrigin: "83.615px 182.235px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "93.63 142.82 101.55 138.25 101.55 154.54 93.63 159.12",
    fill: "#1f1ff9",
    style: {
      transformOrigin: "97.59px 148.685px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "107.6 147.26 115.52 142.69 115.52 183.74 107.6 188.31",
    fill: "#1f1ff9",
    style: {
      transformOrigin: "111.56px 165.5px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "121.58 155.87 129.5 151.3 129.5 168.65 121.58 173.23",
    fill: "#1f1ff9",
    style: {
      transformOrigin: "125.54px 162.265px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "135.55 110.84 143.47 106.27 143.47 148.67 135.55 153.24",
    fill: "#1f1ff9",
    style: {
      transformOrigin: "139.51px 129.755px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "149.53 151.9 157.44 147.33 157.44 167.75 149.53 172.32",
    fill: "#1f1ff9",
    style: {
      transformOrigin: "153.485px 159.825px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "163.5 110.63 171.42 106.06 171.42 152.24 163.5 156.81",
    fill: "#1f1ff9",
    style: {
      transformOrigin: "167.46px 131.435px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "177.48 127.72 185.39 123.15 185.39 139.23 177.48 143.8",
    fill: "#1f1ff9",
    style: {
      transformOrigin: "181.435px 133.475px"
    }
  }), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    fill: "#fff",
    opacity: 0.4,
    style: {
      transformOrigin: "125.535px 164.695px"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "65.68 171.47 73.6 166.89 73.6 218.75 65.68 223.33",
    style: {
      transformOrigin: "69.64px 195.11px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "79.66 175.19 87.57 170.61 87.57 189.29 79.66 193.86",
    style: {
      transformOrigin: "83.615px 182.235px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "93.63 142.82 101.55 138.25 101.55 154.54 93.63 159.12",
    style: {
      transformOrigin: "97.59px 148.685px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "107.6 147.26 115.52 142.69 115.52 183.74 107.6 188.31",
    style: {
      transformOrigin: "111.56px 165.5px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "121.58 155.87 129.5 151.3 129.5 168.65 121.58 173.23",
    style: {
      transformOrigin: "125.54px 162.265px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "135.55 110.84 143.47 106.27 143.47 148.67 135.55 153.24",
    style: {
      transformOrigin: "139.51px 129.755px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "149.53 151.9 157.44 147.33 157.44 167.75 149.53 172.32",
    style: {
      transformOrigin: "153.485px 159.825px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "163.5 110.63 171.42 106.06 171.42 152.24 163.5 156.81",
    style: {
      transformOrigin: "167.46px 131.435px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "177.48 127.72 185.39 123.15 185.39 139.23 177.48 143.8",
    style: {
      transformOrigin: "181.435px 133.475px"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    style: {
      transformOrigin: "93.3554px 316.269px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    className: "animable",
    style: {
      transformOrigin: "93.3554px 316.269px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M136.5,246.24l.2-.05Z",
    fill: "#455a64",
    style: {
      transformOrigin: "136.6px 246.215px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m137.11 246.1z",
    fill: "#455a64",
    style: {
      transformOrigin: "137.11px 246.1px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m137.66 246.11h0.2z",
    fill: "#455a64",
    style: {
      transformOrigin: "137.76px 246.11px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M50.53,387a.8.8,0,0,1-.08-.16A1.19,1.19,0,0,0,50.53,387Z",
    fill: "#455a64",
    style: {
      transformOrigin: "50.49px 386.92px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M51.28,387.78l-.16-.09Z",
    fill: "#455a64",
    style: {
      transformOrigin: "51.2px 387.735px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M52.94,387.8l-.23.06Z",
    fill: "#455a64",
    style: {
      transformOrigin: "52.825px 387.83px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m52.33 388z",
    fill: "#455a64",
    style: {
      transformOrigin: "52.33px 388px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M138.15,246.26l.18.1Z",
    fill: "#455a64",
    style: {
      transformOrigin: "138.24px 246.31px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M50.86,387.47l-.13-.13Z",
    fill: "#455a64",
    style: {
      transformOrigin: "50.795px 387.405px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M51.77,387.94l-.19-.05Z",
    fill: "#455a64",
    style: {
      transformOrigin: "51.675px 387.915px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m50.3 386.42v-0.15s-0.01 0.1 0 0.15z",
    fill: "#455a64",
    style: {
      transformOrigin: "50.2978px 386.338px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M138.89,247a1.28,1.28,0,0,1,.11.2A2,2,0,0,0,138.89,247Z",
    fill: "#455a64",
    style: {
      transformOrigin: "138.945px 247.1px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M139.24,334.18a7.27,7.27,0,0,1-1.48,4.1,7.29,7.29,0,0,0,1.49-4.1V248.49a.28.28,0,0,0,0-.09.28.28,0,0,1,0,.09Z",
    fill: "#455a64",
    style: {
      transformOrigin: "138.507px 293.34px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M139.12,247.56l.06.23Z",
    fill: "#455a64",
    style: {
      transformOrigin: "139.15px 247.675px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M138.56,246.56l.15.15Z",
    fill: "#455a64",
    style: {
      transformOrigin: "138.635px 246.635px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m51.12 387.69a1.38 1.38 0 0 1-0.26-0.22 1.38 1.38 0 0 0 0.26 0.22z",
    fill: "#37474f",
    opacity: 0.9,
    style: {
      transformOrigin: "50.99px 387.58px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m139.18 247.79a3.86 3.86 0 0 1 0 0.61 3.86 3.86 0 0 0 0-0.61z",
    fill: "#37474f",
    opacity: 0.9,
    style: {
      transformOrigin: "139.186px 248.095px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m135.86 340.05-82.28 47.46a4 4 0 0 1-0.64 0.29 4.5 4.5 0 0 0 0.65-0.29l82.27-47.45a6.51 6.51 0 0 0 1.9-1.78 6.34 6.34 0 0 1-1.9 1.77z",
    fill: "#37474f",
    opacity: 0.9,
    style: {
      transformOrigin: "95.35px 363.04px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m52.71 387.86a2.62 2.62 0 0 1-0.38 0.09 2.62 2.62 0 0 0 0.38-0.09z",
    fill: "#37474f",
    opacity: 0.9,
    style: {
      transformOrigin: "52.52px 387.905px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m50.73 387.34a2.36 2.36 0 0 1-0.2-0.31 2.36 2.36 0 0 0 0.2 0.31z",
    fill: "#37474f",
    opacity: 0.9,
    style: {
      transformOrigin: "50.63px 387.185px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m51.58 387.89a1.33 1.33 0 0 1-0.3-0.11 1.33 1.33 0 0 0 0.3 0.11z",
    fill: "#37474f",
    opacity: 0.9,
    style: {
      transformOrigin: "51.43px 387.835px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m52.1 388h-0.33a1.82 1.82 0 0 0 0.33 0z",
    fill: "#37474f",
    opacity: 0.9,
    style: {
      transformOrigin: "51.935px 388.004px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M139,247.19a3.22,3.22,0,0,1,.12.37A3.22,3.22,0,0,0,139,247.19Z",
    fill: "#37474f",
    opacity: 0.9,
    style: {
      transformOrigin: "139.06px 247.375px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m136.7 246.19a2.17 2.17 0 0 1 0.41-0.09 2.17 2.17 0 0 0-0.41 0.09z",
    fill: "#37474f",
    opacity: 0.9,
    style: {
      transformOrigin: "136.905px 246.145px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m138.71 246.71a1.92 1.92 0 0 1 0.18 0.28 2.68 2.68 0 0 0-0.18-0.28z",
    fill: "#37474f",
    opacity: 0.9,
    style: {
      transformOrigin: "138.8px 246.85px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m50.45 386.87a3 3 0 0 1-0.15-0.45 3 3 0 0 0 0.15 0.45z",
    fill: "#37474f",
    opacity: 0.9,
    style: {
      transformOrigin: "50.375px 386.645px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M137.86,246.15l.29.11Z",
    fill: "#37474f",
    opacity: 0.9,
    style: {
      transformOrigin: "138.005px 246.205px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m137.32 246.09a1.88 1.88 0 0 1 0.34 0 1.88 1.88 0 0 0-0.34 0z",
    fill: "#37474f",
    opacity: 0.9,
    style: {
      transformOrigin: "137.49px 246.086px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M138.33,246.36l.23.2Z",
    fill: "#37474f",
    opacity: 0.9,
    style: {
      transformOrigin: "138.445px 246.46px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m50.25 386.23s0 0 0 0z",
    fill: "#37474f",
    opacity: 0.9,
    style: {
      transformOrigin: "50.25px 386.23px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m136.45 246.25h0.05z",
    fill: "#37474f",
    opacity: 0.9,
    style: {
      transformOrigin: "136.475px 246.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M139.23,248.4a3.86,3.86,0,0,0,0-.61l-.06-.23a3.22,3.22,0,0,0-.12-.37,1.28,1.28,0,0,0-.11-.2,1.92,1.92,0,0,0-.18-.28l-.15-.15-.23-.2-.18-.1-.29-.11-.2,0a1.88,1.88,0,0,0-.34,0h-.21a2.17,2.17,0,0,0-.41.09l-.2.05-.05,0a4,4,0,0,0-.6.28L53.58,294a7.5,7.5,0,0,0-3.39,5.87v85.69a3.64,3.64,0,0,0,.07.68v0c0,.06,0,.1,0,.15a3,3,0,0,0,.15.45.8.8,0,0,0,.08.16,2.36,2.36,0,0,0,.2.31l.13.13a1.38,1.38,0,0,0,.26.22l.16.09a1.33,1.33,0,0,0,.3.11l.19.05h.56a2.62,2.62,0,0,0,.38-.09l.23-.06a4,4,0,0,0,.64-.29l82.28-47.46a6.34,6.34,0,0,0,1.9-1.77,7.27,7.27,0,0,0,1.48-4.1V248.49A.28.28,0,0,0,139.23,248.4Z",
    fill: "#455a64",
    opacity: 0.8,
    style: {
      transformOrigin: "94.716px 317.026px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M138.21,246.29h0l-2.66-1.52a1.79,1.79,0,0,0-.93-.24,3,3,0,0,0-1.5.45L50.84,292.43A7,7,0,0,0,48.43,295l2.74,1.58A6.8,6.8,0,0,1,53.59,294l82.26-47.46a4,4,0,0,1,.6-.28,3.44,3.44,0,0,1,.06.68v85.68a7.53,7.53,0,0,1-3.38,5.88L53.59,384.37v3.14l82.26-47.46a7.46,7.46,0,0,0,3.39-5.87V248.5A2.32,2.32,0,0,0,138.21,246.29Z",
    fill: "#37474f",
    opacity: 0.5,
    style: {
      transformOrigin: "93.843px 316.02px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M53.59,384.37v3.14a3.14,3.14,0,0,1-1.52.46,1.76,1.76,0,0,1-.89-.23l-2.71-1.55a2.35,2.35,0,0,1-1-2.2V298.3a7,7,0,0,1,1-3.32l2.74,1.58a6.89,6.89,0,0,0-1,3.31v85.68a4.68,4.68,0,0,0,0,.67,3.09,3.09,0,0,0,.59-.27Z",
    fill: "#37474f",
    opacity: 0.9,
    style: {
      transformOrigin: "50.5224px 341.475px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m135.85 246.54-68.2 40.08-13.35 7.68a6.69 6.69 0 0 0-3 3.48 5.75 5.75 0 0 0-0.45 2.27v7.7l-0.61 77.8-0.6-77.8v-7.7a6.88 6.88 0 0 1 0.53-2.73 8.7 8.7 0 0 1 1.35-2.32 6.88 6.88 0 0 1 2.15-1.74l4.45-2.58 8.88-5.19z",
    fill: "#fff",
    opacity: 0.4,
    style: {
      transformOrigin: "92.7448px 316.045px"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "animable",
    cx: 94.39,
    cy: 318.27,
    rx: 39.83,
    ry: 22.53,
    fill: "#1f1ff9",
    style: {
      transformOrigin: "94.39px 318.27px",
      transform: "rotate(-66.95deg)"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "animable",
    cx: 94.39,
    cy: 318.27,
    rx: 39.83,
    ry: 22.53,
    fill: "#fafafa",
    style: {
      transformOrigin: "94.39px 318.27px",
      transform: "rotate(-66.95deg)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m109.64 337.45c6.49-10 10.7-22.65 10.7-34.16 0-19.11-11.62-27.89-25.95-19.62v34.6z",
    fill: "#1f1ff9",
    style: {
      transformOrigin: "107.365px 309.004px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m109.64 337.45c6.49-10 10.7-22.65 10.7-34.16 0-19.11-11.62-27.89-25.95-19.62v34.6z",
    fill: "#fff",
    opacity: 0.4,
    style: {
      transformOrigin: "107.365px 309.004px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M65.73,310.59c-.16-1.47-.65-5.79-.93-8.33-.13-1.12-.89-1.56-1.79-1h0l-.48.28-4.75,2.74-.48.28h0a4.28,4.28,0,0,0-1.79,3.1l-.93,9.4c-.06.58.19,1,.58.87a1.71,1.71,0,0,0,1-1.42l.8-8.59a.58.58,0,0,1,.24-.43h0c.15-.08.26,0,.24.23L56.29,320.5l1.49-.86v8c0,.71.44,1,1,.73h0a2.33,2.33,0,0,0,1-1.86v-8l.85-.5v8c0,.72.44,1.05,1,.73h0a2.34,2.34,0,0,0,1-1.86v-8L64,316,62.9,304.52a.56.56,0,0,1,.24-.51h0c.12-.08.23,0,.25.14l.79,7.66c.07.57.51.73,1,.32A2,2,0,0,0,65.73,310.59Z",
    fill: "#37474f",
    style: {
      transformOrigin: "60.1536px 314.743px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m58.22 300.32a4.63 4.63 0 0 1 1.94-3.71c1.07-0.62 1.93 0 1.93 1.47a4.64 4.64 0 0 1-1.93 3.7c-1.08 0.62-1.94-0.04-1.94-1.46z",
    fill: "#37474f",
    style: {
      transformOrigin: "60.155px 299.192px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m126.74 310.36a4.66 4.66 0 0 1 1.94-3.71c1.07-0.62 1.94 0 1.94 1.47a4.65 4.65 0 0 1-1.94 3.7c-1.07 0.62-1.94-0.04-1.94-1.46z",
    fill: "#37474f",
    style: {
      transformOrigin: "128.68px 309.232px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M131.54,311.26l-.48.28-4.75,2.74-.49.28-.16.09a3.35,3.35,0,0,0-1.4,2.68h0v9.22c0,.58.35.84.78.59h0a1.88,1.88,0,0,0,.78-1.49v-7.91a.57.57,0,0,1,.25-.46h0c.13-.08.24,0,.24.18v20.26c0,.71.43,1,1,.73h0a2.32,2.32,0,0,0,1-1.86V326.33a1,1,0,0,1,.43-.82h0c.24-.14.43,0,.43.32V336.1c0,.72.44,1,1,.74h0a2.36,2.36,0,0,0,1-1.87V314.72a.56.56,0,0,1,.24-.46h0c.13-.08.24,0,.24.18v7.91c0,.58.35.84.78.59h0a1.89,1.89,0,0,0,.79-1.5v-9.22h0c0-1-.63-1.5-1.4-1.06Z",
    fill: "#37474f",
    style: {
      transformOrigin: "128.74px 324.775px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M87.56,341.65a1.07,1.07,0,0,0-.94.58L60.37,335v-4.1a.21.21,0,0,0-.21-.21.21.21,0,0,0-.21.21v4.26a.21.21,0,0,0,.15.2l26.41,7.33a.24.24,0,0,0,0,.08,1.07,1.07,0,1,0,1.07-1.07Z",
    fill: "#1f1ff9",
    style: {
      transformOrigin: "74.3px 337.265px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M87.56,341.65a1.07,1.07,0,0,0-.94.58L60.37,335v-4.1a.21.21,0,0,0-.21-.21.21.21,0,0,0-.21.21v4.26a.21.21,0,0,0,.15.2l26.41,7.33a.24.24,0,0,0,0,.08,1.07,1.07,0,1,0,1.07-1.07Z",
    fill: "#fff",
    opacity: 0.25,
    style: {
      transformOrigin: "74.3px 337.265px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M128.74,299.83l-23-6.38a.14.14,0,0,0,0-.07,1.07,1.07,0,1,0-1.07,1.07,1.06,1.06,0,0,0,.94-.59l22.83,6.34v4a.22.22,0,0,0,.21.21.21.21,0,0,0,.21-.21V300A.22.22,0,0,0,128.74,299.83Z",
    fill: "#37474f",
    style: {
      transformOrigin: "116.23px 298.36px"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    style: {
      transformOrigin: "246.301px 221.644px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    className: "animable",
    style: {
      transformOrigin: "246.301px 221.644px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m340.14 96.53a2.35 2.35 0 0 0-1-2.21l-2.66-1.52a2.35 2.35 0 0 0-2.48 0.2l-178.15 102.88a7.5 7.5 0 0 0-3.39 5.87v145a2.37 2.37 0 0 0 1 2.2l2.72 1.55a2.37 2.37 0 0 0 2.4-0.23l178.18-102.87a7.5 7.5 0 0 0 3.39-5.87z",
    fill: "#1f1ff9",
    opacity: 0.1,
    style: {
      transformOrigin: "246.301px 221.631px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m336.75 94.58-178.17 102.87a7.47 7.47 0 0 0-3.38 5.87v145c0 2.16 1.51 3 3.39 2l178.17-102.92a7.5 7.5 0 0 0 3.39-5.87v-145c-0.01-2.16-1.52-3.04-3.4-1.95z",
    fill: "#1f1ff9",
    opacity: 0.1,
    style: {
      transformOrigin: "247.675px 222.425px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M340.14,96.53v145a7.49,7.49,0,0,1-3.38,5.87L158.59,350.27c-1.67,1-3.05.38-3.34-1.28a5.26,5.26,0,0,0,.6-.28L334,245.84a7.5,7.5,0,0,0,3.39-5.87V95a3.58,3.58,0,0,0-.06-.68C338.94,93.7,340.14,94.61,340.14,96.53Z",
    fill: "#1f1ff9",
    opacity: 0.15,
    style: {
      transformOrigin: "247.695px 222.439px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M336.75,94.58l-75.32,43.88L226,159.18l-35.54,20.6-17.77,10.29-8.9,5.13-4.45,2.56a6.62,6.62,0,0,0-3,3.48,5.75,5.75,0,0,0-.45,2.27v18l0,20.53-.12,41.08-.18,4.36-.27,60.86-.28-60.86-.18-4.36L154.63,242l0-20.53v-18a6.93,6.93,0,0,1,.53-2.74,8.73,8.73,0,0,1,1.42-2.36,8.41,8.41,0,0,1,1-1,8.63,8.63,0,0,1,1.15-.75l4.45-2.58L172,189l17.81-10.24,35.6-20.48,35.68-20.37Z",
    fill: "#fff",
    style: {
      transformOrigin: "245.69px 221.46px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M323.84,117.34l-8.9,5.14-.66.38-8.9,5.14-.66.38-8.91,5.14-.65.38L286.25,139l-.66.38-8.9,5.14-.66.38-8.9,5.14-.66.38-8.91,5.14-.66.38-8.43,4.88-.47.27-.66.38-8.9,5.13-.66.39-8.91,5.14-.65.38-9.57,5.52-8.9,5.14-.66.38-8,4.6-.93.54-.66.38-8.91,5.14-.66.38-8.9,5.15-.66.37-8.9,5.14-.66.38v98.74L324,216l.49-.29V117ZM180.4,298l-8.9,5.14v-13.1l8.9-5.14Zm0-14-8.9,5.14v-13.1l8.9-5.14Zm0-14-8.9,5.13v-13.1l8.9-5.13Zm0-14-8.9,5.15v-13.1l8.9-5.15Zm0-14-8.9,5.14v-13.1l8.9-5.14Zm0-14-8.9,5.13v-13.1l8.9-5.13Zm0-14-8.9,5.15v-13.1l8.9-5.15ZM190,292.49l-8.9,5.14v-13.1l8.9-5.14Zm0-14-8.9,5.14v-13.1l8.9-5.14Zm0-14-8.9,5.14v-13.1l8.9-5.14Zm0-14-8.9,5.14v-13.1l8.9-5.14Zm0-14-8.9,5.14v-13.1l8.9-5.14Zm0-14-8.9,5.14v-13.1l8.9-5.14Zm0-14-8.9,5.13v-13.1l8.9-5.13ZM199.53,287l-8.91,5.13V279l8.91-5.14Zm0-14-8.91,5.14V265l8.91-5.14Zm0-14-8.91,5.14v-13.1l8.91-5.14Zm0-14-8.91,5.14v-13.1l8.91-5.14Zm0-14-8.91,5.14v-13.1l8.91-5.14Zm0-14-8.91,5.14v-13.1l8.91-5.14Zm0-14-8.91,5.14v-13.1l8.91-5.14Zm9.56,78.35-8.9,5.15v-13.1l8.9-5.15Zm0-14-8.9,5.14v-13.1l8.9-5.14Zm0-14-8.9,5.14v-13.1l8.9-5.14Zm0-14-8.9,5.14v-13.1l8.9-5.14Zm0-14-8.9,5.14v-13.1l8.9-5.14Zm0-14-8.9,5.14v-13.1l8.9-5.14Zm0-14-8.9,5.14v-13.1l8.9-5.14Zm9.56,78.36-8.9,5.13V268l8.9-5.13Zm0-14-8.9,5.14V254l8.9-5.14Zm0-14-8.9,5.15V240l8.9-5.15Zm0-14-8.9,5.13V226l8.9-5.13Zm0-14-8.9,5.14v-13.1l8.9-5.14Zm0-14-8.9,5.14v-13.1l8.9-5.14Zm0-14-8.9,5.14v-13.1l8.9-5.14Zm9.57,78.35-8.91,5.15v-13.1l8.91-5.15Zm0-14-8.91,5.14V248.47l8.91-5.14Zm0-14-8.91,5.13V234.49l8.91-5.14Zm0-14-8.91,5.14v-13.1l8.91-5.15Zm0-14-8.91,5.14V206.52l8.91-5.13Zm0-14-8.91,5.14v-13.1l8.91-5.14Zm0-14-8.91,5.14v-13.1l8.91-5.15Zm9.56,78.35L228.87,270v-13.1l8.91-5.13Zm0-14-8.91,5.14V243l8.91-5.14Zm0-14-8.91,5.15V229l8.91-5.15Zm0-14-8.91,5.13V215l8.91-5.13Zm0-14-8.91,5.14V201l8.91-5.14Zm0-14-8.91,5.15V187l8.91-5.15Zm0-14-8.91,5.13V173l8.91-5.13Zm9.56,78.35-8.9,5.15v-13.1l8.9-5.15Zm0-14-8.9,5.14v-13.1l8.9-5.14Zm0-14-8.9,5.13v-13.1l8.9-5.13Zm0-14-8.9,5.15v-13.1l8.9-5.15Zm0-14-8.9,5.14v-13.1l8.9-5.14Zm0-14-8.9,5.13V181.51l8.9-5.14Zm0-14-8.9,5.15v-13.1l8.9-5.15Zm9.56,78.36L248,259v-13.1l8.9-5.14Zm0-14L248,245V231.9l8.9-5.14Zm0-14L248,231v-13.1l8.9-5.15Zm0-14L248,217v-13.1l8.9-5.13Zm0-14-8.9,5.14V190l8.9-5.15Zm0-14-8.9,5.15V176l8.9-5.15Zm0-14L248,175.1V162l8.9-5.13Zm9.57,78.35-8.91,5.14v-13.1l8.91-5.14Zm0-14-8.91,5.14v-13.1l8.91-5.14Zm0-14-8.91,5.14V212.4l8.91-5.13Zm0-14-8.91,5.15v-13.1l8.91-5.15Zm0-14-8.91,5.14v-13.1l8.91-5.14Zm0-14-8.91,5.13v-13.1l8.91-5.13Zm0-14-8.91,5.15v-13.1l8.91-5.15ZM276,242.8l-8.9,5.14v-13.1l8.9-5.14Zm0-14-8.9,5.14v-13.1l8.9-5.14Zm0-14-8.9,5.14v-13.1l8.9-5.14Zm0-14-8.9,5.14V192.9l8.9-5.14Zm0-14-8.9,5.14v-13.1l8.9-5.14Zm0-14-8.9,5.14v-13.1l8.9-5.14Zm0-14-8.9,5.14V151l8.9-5.14Zm9.56,78.36-8.9,5.13v-13.1l8.9-5.13Zm0-14-8.9,5.14v-13.1l8.9-5.14Zm0-14-8.9,5.14v-13.1l8.9-5.14Zm0-14-8.9,5.14v-13.1l8.9-5.14Zm0-14-8.9,5.14V173.4l8.9-5.14Zm0-14-8.9,5.14v-13.1l8.9-5.14Zm0-14-8.9,5.15V145.44l8.9-5.14Zm9.57,78.35-8.91,5.15V223.8l8.91-5.14Zm0-14-8.91,5.14v-13.1l8.91-5.14Zm0-14-8.91,5.14v-13.1l8.91-5.14Zm0-14L286.25,195v-13.1l8.91-5.14Zm0-14L286.25,181v-13.1l8.91-5.14Zm0-14L286.25,167V153.9l8.91-5.14Zm0-14L286.25,153v-13.1l8.91-5.14Zm9.56,78.36-8.91,5.13v-13.1l8.91-5.13Zm0-14-8.91,5.14V204.3l8.91-5.14Zm0-14-8.91,5.15v-13.1l8.91-5.15Zm0-14-8.91,5.13v-13.1l8.91-5.13Zm0-14-8.91,5.14v-13.1l8.91-5.14Zm0-14-8.91,5.14v-13.1l8.91-5.14Zm0-14-8.91,5.14V134.4l8.91-5.14Zm9.56,78.35-8.9,5.15v-13.1l8.9-5.15Zm0-14-8.9,5.15v-13.1l8.9-5.15Zm0-14-8.9,5.13v-13.1l8.9-5.13Zm0-14-8.9,5.14v-13.1l8.9-5.15Zm0-14-8.9,5.14v-13.1l8.9-5.14Zm0-14-8.9,5.14v-13.1l8.9-5.14Zm0-14-8.9,5.15v-13.1l8.9-5.15Zm9.56,78.36-8.9,5.14v-13.1l8.9-5.14Zm0-14-8.9,5.13V193.26l8.9-5.14Zm0-14-8.9,5.15v-13.1l8.9-5.15Zm0-14-8.9,5.13v-13.1l8.9-5.13Zm0-14-8.9,5.14v-13.1l8.9-5.14Zm0-14-8.9,5.15v-13.1l8.9-5.15Zm0-14-8.9,5.13v-13.1l8.9-5.13Z",
    fill: "#fff",
    opacity: 0.3,
    style: {
      transformOrigin: "247.65px 210.685px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "324.5 215.69 324.5 122.61 309.14 158.62 293.77 169.25 278.4 187.58 263.04 193.65 247.67 212.09 232.3 208.94 216.94 224.12 201.57 246.63 186.2 255.5 170.84 283.84 170.84 304.41",
    fill: "#1f1ff9",
    style: {
      transformOrigin: "247.67px 213.51px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "324.5 215.69 324.5 122.61 309.14 158.62 293.77 169.25 278.4 187.58 263.04 193.65 247.67 212.09 232.3 208.94 216.94 224.12 201.57 246.63 186.2 255.5 170.84 283.84 170.84 304.41",
    fill: "#fff",
    opacity: 0.7,
    style: {
      transformOrigin: "247.67px 213.51px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M170.84,316.17a.42.42,0,0,1-.37-.21.42.42,0,0,1,.16-.57l153.66-88.72a.42.42,0,1,1,.42.73L171.05,316.12A.54.54,0,0,1,170.84,316.17Z",
    fill: "#455a64",
    style: {
      transformOrigin: "247.669px 271.392px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M170.84,319.57a.42.42,0,0,1-.42-.43v-6.78a.42.42,0,0,1,.42-.42.42.42,0,0,1,.42.42v6.78A.42.42,0,0,1,170.84,319.57Z",
    fill: "#455a64",
    style: {
      transformOrigin: "170.84px 315.755px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M186.2,310.69a.42.42,0,0,1-.42-.42v-6.78a.43.43,0,1,1,.85,0v6.78A.42.42,0,0,1,186.2,310.69Z",
    fill: "#455a64",
    style: {
      transformOrigin: "186.205px 306.842px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M201.57,301.82a.42.42,0,0,1-.42-.42v-6.79a.42.42,0,1,1,.84,0v6.79A.42.42,0,0,1,201.57,301.82Z",
    fill: "#455a64",
    style: {
      transformOrigin: "201.57px 298.005px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M216.94,293a.42.42,0,0,1-.42-.42v-6.79a.42.42,0,0,1,.42-.42.42.42,0,0,1,.42.42v6.79A.42.42,0,0,1,216.94,293Z",
    fill: "#455a64",
    style: {
      transformOrigin: "216.94px 289.185px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M232.3,284.08a.42.42,0,0,1-.42-.42v-6.79a.43.43,0,0,1,.85,0v6.79A.42.42,0,0,1,232.3,284.08Z",
    fill: "#455a64",
    style: {
      transformOrigin: "232.305px 280.293px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M247.67,275.21a.42.42,0,0,1-.42-.43V268a.42.42,0,0,1,.84,0v6.78A.42.42,0,0,1,247.67,275.21Z",
    fill: "#455a64",
    style: {
      transformOrigin: "247.67px 271.395px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M263,266.33a.42.42,0,0,1-.42-.42v-6.78a.41.41,0,0,1,.42-.42.42.42,0,0,1,.42.42v6.78A.42.42,0,0,1,263,266.33Z",
    fill: "#455a64",
    style: {
      transformOrigin: "263px 262.52px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M278.4,257.46A.42.42,0,0,1,278,257v-6.78a.43.43,0,1,1,.85,0V257A.42.42,0,0,1,278.4,257.46Z",
    fill: "#455a64",
    style: {
      transformOrigin: "278.425px 253.593px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M293.77,248.59a.42.42,0,0,1-.42-.42v-6.79a.42.42,0,1,1,.84,0v6.79A.42.42,0,0,1,293.77,248.59Z",
    fill: "#455a64",
    style: {
      transformOrigin: "293.77px 244.775px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M309.14,239.72a.42.42,0,0,1-.43-.42v-6.79a.43.43,0,0,1,.85,0v6.79A.42.42,0,0,1,309.14,239.72Z",
    fill: "#455a64",
    style: {
      transformOrigin: "309.135px 235.933px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M324.5,230.85a.42.42,0,0,1-.42-.43v-6.78a.43.43,0,0,1,.85,0v6.78A.43.43,0,0,1,324.5,230.85Z",
    fill: "#455a64",
    style: {
      transformOrigin: "324.505px 227.063px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "324.5 215.69 324.5 147.55 309.14 178.2 293.77 182.06 278.4 197.94 263.04 203.03 247.67 217.61 232.3 215.29 216.94 230.17 201.57 254.61 186.2 265.9 170.84 289.64 170.84 304.41",
    fill: "#1f1ff9",
    style: {
      transformOrigin: "247.67px 225.98px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "324.5 215.69 324.5 147.55 309.14 178.2 293.77 182.06 278.4 197.94 263.04 203.03 247.67 217.61 232.3 215.29 216.94 230.17 201.57 254.61 186.2 265.9 170.84 289.64 170.84 304.41",
    fill: "#fff",
    opacity: 0.4,
    style: {
      transformOrigin: "247.67px 225.98px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "170.84 304.41 324.5 215.69 324.5 167.73 308.71 194.68 293.77 198.12 278.83 222.32 263.04 223.66 248.18 236.39 232.3 228.89 216.94 240.89 201.57 266.51 186.2 274.78 170.84 294.56",
    fill: "#1f1ff9",
    style: {
      transformOrigin: "247.67px 236.07px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m186.19 295.55 15.38-8.88v-40l-15.37 8.83zm30.75-17.75 15.36-8.88v-60l-15.36 15.18zm30.73-17.75 15.33-8.87v-57.53l-15.37 18.44zm30.73-17.74 15.37-8.87v-64.19l-15.37 18.33zm30.74-83.69v65.94l15.36-8.87v-93.08z",
    fill: "#1f1ff9",
    opacity: 0.2,
    style: {
      transformOrigin: "255.345px 209.08px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m247.67 236.15v23.9l6.07-3.5 9.3-5.37v-27.52l-14.86 12.73zm-61.47 38.64v20.76l15.38-8.88v-20.15l-15.37 8.26zm30.74 3 5.12-3 10.24-5.92v-40l-15.36 12zm92.2-83.79v30.61l15.36-8.87v-48zm-30.74 28.4v20l15.37-8.87v-35.41l-14.94 24.2z",
    opacity: 0.15,
    style: {
      transformOrigin: "255.35px 231.645px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M189.42,316.32,183,320a1.74,1.74,0,0,0-.74,1.4v.15c0,.54.33.79.74.55l6.43-3.71a1.77,1.77,0,0,0,.74-1.41v-.14C190.16,316.34,189.83,316.09,189.42,316.32Z",
    fill: "#37474f",
    style: {
      transformOrigin: "186.215px 319.213px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m204.79 307.45-6.44 3.72a1.76 1.76 0 0 0-0.73 1.4v0.15c0 0.54 0.33 0.79 0.73 0.55l6.44-3.71a1.77 1.77 0 0 0 0.73-1.41v-0.15c0-0.54-0.32-0.78-0.73-0.55z",
    fill: "#37474f",
    style: {
      transformOrigin: "201.57px 310.362px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m220.16 298.58-6.44 3.72a1.74 1.74 0 0 0-0.74 1.4v0.15c0 0.54 0.33 0.79 0.74 0.55l6.44-3.72a1.76 1.76 0 0 0 0.73-1.4v-0.15c0-0.54-0.33-0.79-0.73-0.55z",
    fill: "#37474f",
    style: {
      transformOrigin: "216.935px 301.49px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m235.52 289.71-6.43 3.71a1.77 1.77 0 0 0-0.74 1.41v0.17c0 0.54 0.33 0.79 0.74 0.56l6.43-3.72a1.74 1.74 0 0 0 0.74-1.4v-0.15c0-0.57-0.33-0.82-0.74-0.58z",
    fill: "#37474f",
    style: {
      transformOrigin: "232.305px 292.632px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m250.89 280.83-6.44 3.72a1.78 1.78 0 0 0-0.73 1.41v0.14c0 0.54 0.33 0.79 0.73 0.56l6.44-3.72a1.73 1.73 0 0 0 0.73-1.4v-0.15c0-0.54-0.32-0.79-0.73-0.56z",
    fill: "#37474f",
    style: {
      transformOrigin: "247.67px 283.745px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M266.26,272l-6.44,3.72a1.74,1.74,0,0,0-.74,1.4v.15c0,.54.33.79.74.56l6.44-3.72a1.78,1.78,0,0,0,.73-1.41v-.14C267,272,266.66,271.73,266.26,272Z",
    fill: "#37474f",
    style: {
      transformOrigin: "263.035px 274.905px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M281.62,263.09l-6.44,3.72a1.76,1.76,0,0,0-.73,1.4v.15c0,.54.33.79.73.55l6.44-3.71a1.77,1.77,0,0,0,.74-1.41v-.14C282.36,263.1,282,262.86,281.62,263.09Z",
    fill: "#37474f",
    style: {
      transformOrigin: "278.405px 266.002px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M297,254.22l-6.44,3.72a1.76,1.76,0,0,0-.73,1.4v.15c0,.54.33.79.73.55l6.44-3.72a1.73,1.73,0,0,0,.73-1.4v-.15C297.72,254.23,297.4,254,297,254.22Z",
    fill: "#37474f",
    style: {
      transformOrigin: "293.78px 257.134px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m312.36 245.35-6.44 3.71a1.77 1.77 0 0 0-0.74 1.41v0.14c0 0.55 0.33 0.79 0.74 0.56l6.44-3.72a1.76 1.76 0 0 0 0.73-1.4v-0.15c0-0.54-0.33-0.79-0.73-0.55z",
    fill: "#37474f",
    style: {
      transformOrigin: "309.135px 248.258px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M186.2,246.43a.42.42,0,0,1-.42-.42V221.34a.43.43,0,0,1,.85,0V246A.42.42,0,0,1,186.2,246.43Z",
    fill: "#1f1ff9",
    style: {
      transformOrigin: "186.205px 233.703px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m184.67 222.23a2.08 2.08 0 0 1-1.1-0.29 2.8 2.8 0 0 1-1.21-2.58 7.93 7.93 0 0 1 3.63-6.3 2.5 2.5 0 0 1 4.06 2.34 7.93 7.93 0 0 1-3.63 6.3 3.55 3.55 0 0 1-1.75 0.53zm3.06-8.85a2.71 2.71 0 0 0-1.31 0.41 7.11 7.11 0 0 0-3.22 5.57 1.68 1.68 0 0 0 2.8 1.64 7.09 7.09 0 0 0 3.22-5.57 2 2 0 0 0-0.79-1.85 1.41 1.41 0 0 0-0.7-0.2zm-1.53 0.05z",
    fill: "#1f1ff9",
    style: {
      transformOrigin: "186.216px 217.358px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M232.3,199.87a.42.42,0,0,1-.42-.42V189.23a.43.43,0,0,1,.85,0v10.22A.42.42,0,0,1,232.3,199.87Z",
    fill: "#1f1ff9",
    style: {
      transformOrigin: "232.305px 194.368px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m230.77 190.12a2.18 2.18 0 0 1-1.1-0.29 2.8 2.8 0 0 1-1.21-2.58 7.92 7.92 0 0 1 3.63-6.3 2.5 2.5 0 0 1 4.06 2.34 8 8 0 0 1-3.63 6.3 3.55 3.55 0 0 1-1.75 0.53zm3.06-8.85a2.71 2.71 0 0 0-1.31 0.41 7.09 7.09 0 0 0-3.22 5.57 1.68 1.68 0 0 0 2.79 1.61 7.09 7.09 0 0 0 3.22-5.57 2 2 0 0 0-0.79-1.85 1.31 1.31 0 0 0-0.69-0.17zm-1.53 0z",
    fill: "#1f1ff9",
    style: {
      transformOrigin: "232.316px 185.248px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M278.4,178.51a.42.42,0,0,1-.42-.42V161.83a.43.43,0,0,1,.85,0v16.26A.42.42,0,0,1,278.4,178.51Z",
    fill: "#1f1ff9",
    style: {
      transformOrigin: "278.405px 169.988px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m276.87 162.73a2.18 2.18 0 0 1-1.1-0.29 2.8 2.8 0 0 1-1.21-2.58 7.9 7.9 0 0 1 3.63-6.3 2.5 2.5 0 0 1 4.06 2.34 7.93 7.93 0 0 1-3.64 6.3 3.49 3.49 0 0 1-1.74 0.53zm3.06-8.85a2.67 2.67 0 0 0-1.32 0.41 7.11 7.11 0 0 0-3.21 5.57 1.68 1.68 0 0 0 2.79 1.61 7.09 7.09 0 0 0 3.22-5.57 2 2 0 0 0-0.79-1.85 1.31 1.31 0 0 0-0.69-0.17z",
    fill: "#1f1ff9",
    style: {
      transformOrigin: "278.416px 157.858px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M170.86,271.35a.8.8,0,0,1-.4-.11.83.83,0,0,1-.34-1.14l12.33-22.76a1,1,0,0,1,.32-.33L201,236.5l15.26-22.35.1-.12,15.37-15.18a.83.83,0,0,1,.76-.23l14.88,3,15-18a.84.84,0,0,1,.34-.25l15.16-6,15.23-18.17a.8.8,0,0,1,.17-.15l11.94-8.25L320.5,115a.85.85,0,0,1,1.11-.45.84.84,0,0,1,.44,1.11l-15.36,36a.84.84,0,0,1-.3.37l-12.05,8.32-15.29,18.25a.81.81,0,0,1-.34.24l-15.16,6-15.23,18.27a.85.85,0,0,1-.82.29l-14.92-3.06-15,14.81-15.32,22.44a.77.77,0,0,1-.28.26l-18.17,10.49L171.6,270.9A.83.83,0,0,1,170.86,271.35Z",
    fill: "#fff",
    style: {
      transformOrigin: "246.068px 192.917px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M322.45,122.33a.85.85,0,0,1-.85-.85v-6l-5.09,3a.85.85,0,0,1-1.15-.31.84.84,0,0,1,.3-1.15l6.36-3.7a.86.86,0,0,1,.85,0,.84.84,0,0,1,.42.73v7.51A.85.85,0,0,1,322.45,122.33Z",
    fill: "#fff",
    style: {
      transformOrigin: "319.267px 117.769px"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    className: "animable animator-active",
    style: {
      transformOrigin: "237.68px 93.86px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    className: "animable",
    style: {
      transformOrigin: "237.68px 93.86px"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "245.59 84.29 240.78 81.5 250.1 73.55 254.92 76.33",
    fill: "#1f1ff9",
    style: {
      transformOrigin: "247.85px 78.92px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M248.56,86.12c-2.47-1.74-6.75-.42-10.37.72-.87.29-1.66.55-2.38.77a4.44,4.44,0,0,0-.35,1.68c0,2.81,2.38,2,7.55.34a37.66,37.66,0,0,1,5.35-1.41c.16,1.43,1.15,2.73,5,.69Z",
    fill: "#1f1ff9",
    style: {
      transformOrigin: "244.41px 88.2097px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "236.62 122.67 231.8 119.89 231.8 114.2 236.62 116.99",
    fill: "#1f1ff9",
    style: {
      transformOrigin: "234.21px 118.435px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m244.78 101.07c0 2.26-1.7 4.28-4.22 5.74-4 2.34-5.58 0.44-5.92-1.42l-0.85-0.49a9.06 9.06 0 0 0 2-0.87 8.57 8.57 0 0 0 3.93-4.15c2.92-0.98 5.06-1.36 5.06 1.19z",
    fill: "#1f1ff9",
    style: {
      transformOrigin: "239.285px 103.514px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M226.86,115a3.2,3.2,0,0,0-1.76-.43c-.1-.29-.18-.58-.26-.9L220,110.9a6,6,0,0,0,2.7,4.12h0l4.81,2.78A2.26,2.26,0,0,0,226.86,115Z",
    fill: "#1f1ff9",
    style: {
      transformOrigin: "223.873px 114.35px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M243,89.63c-5.17,1.7-7.55,2.47-7.55-.34a4.44,4.44,0,0,1,.35-1.68c-3.53,1.09-5.17,1.23-5.17-1.1,0-1.72,1.16-3.83,4.35-5.69,3.41-2,5.31-1.51,5.79.68l9.32-8c0-.12-.09-.23-.13-.35a6.1,6.1,0,0,0,1.65-.63l-3.84-2.29-.37-.22-.06,0h0a6.54,6.54,0,0,0-3.66-.6,16.08,16.08,0,0,0-4.82,1.33v-.1l4.82-2.81-4.82-2.78h0L235.6,67l-4.42,2.57h0v5.69c-6.53,4.75-10.61,11-10.61,17.68,0,3.06.83,4.8,2.16,5.68h0l.07,0,.35.2,4,2.27a3,3,0,0,0-.24-1.82,22.8,22.8,0,0,0,3.78-.82c4.9-1.48,9.25-3.81,9.25-.18a4.58,4.58,0,0,1-.29,1.6c3-1,5.11-1.36,5.11,1.19,0,2.26-1.7,4.28-4.22,5.74-4,2.34-5.58.44-5.92-1.42h0l-.85-.49-4-2.3-9.8,8.3,4.82,2.79a8.8,8.8,0,0,0,.74,2,15.57,15.57,0,0,0,6.22-1.53v2.3l7.62-1v-5.68c6.6-4.87,11.15-11.42,11.15-18.27a9.35,9.35,0,0,0-.54-3.44A26.89,26.89,0,0,0,243,89.63Z",
    fill: "#1f1ff9",
    style: {
      transformOrigin: "235.79px 90.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M243,89.63c-5.17,1.7-7.55,2.47-7.55-.34a4.44,4.44,0,0,1,.35-1.68c-3.53,1.09-5.17,1.23-5.17-1.1,0-1.72,1.16-3.83,4.35-5.69,3.41-2,5.31-1.51,5.79.68l9.32-8c0-.12-.09-.23-.13-.35a6.1,6.1,0,0,0,1.65-.63l-3.84-2.29-.37-.22-.06,0h0a6.54,6.54,0,0,0-3.66-.6,16.08,16.08,0,0,0-4.82,1.33v-.1l4.82-2.81-4.82-2.78h0L235.6,67l-4.42,2.57h0v5.69c-6.53,4.75-10.61,11-10.61,17.68,0,3.06.83,4.8,2.16,5.68h0l.07,0,.35.2,4,2.27a3,3,0,0,0-.24-1.82,22.8,22.8,0,0,0,3.78-.82c4.9-1.48,9.25-3.81,9.25-.18a4.58,4.58,0,0,1-.29,1.6c3-1,5.11-1.36,5.11,1.19,0,2.26-1.7,4.28-4.22,5.74-4,2.34-5.58.44-5.92-1.42h0l-.85-.49-4-2.3-9.8,8.3,4.82,2.79a8.8,8.8,0,0,0,.74,2,15.57,15.57,0,0,0,6.22-1.53v2.3l7.62-1v-5.68c6.6-4.87,11.15-11.42,11.15-18.27a9.35,9.35,0,0,0-.54-3.44A26.89,26.89,0,0,0,243,89.63Z",
    fill: "#fff",
    opacity: 0.4,
    style: {
      transformOrigin: "235.79px 90.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M250,88.06a26.89,26.89,0,0,0-7,1.57c-5.17,1.7-7.55,2.47-7.55-.34a4.44,4.44,0,0,1,.35-1.68,9.07,9.07,0,0,1,4-4c3.41-2,5.31-1.5,5.79.69l9.32-8a5.46,5.46,0,0,0-5.41-4.15,14.51,14.51,0,0,0-5.82,1.36V67.85l-4.82,2.81L236,72.32V78c-6.53,4.76-10.61,11-10.61,17.68a9.9,9.9,0,0,0,.58,3.66c1.44,3.61,5.39,3.11,9.55,1.89,1.46-.44,2.88-.95,4.15-1.36,3-1,5.11-1.36,5.11,1.19,0,2.26-1.7,4.28-4.22,5.74-4,2.34-5.58.44-5.92-1.42l-9.8,8.3a8.8,8.8,0,0,0,.74,2c1.28,2.4,3.56,3,6.22,2.7a18.46,18.46,0,0,0,4.82-1.44v5.68l7.62-4.4v-5.72c6.6-4.86,11.15-11.41,11.15-18.27C255.39,89.35,253.05,88,250,88.06Z",
    fill: "#1f1ff9",
    style: {
      transformOrigin: "240.115px 95.235px"
    }
  }), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    opacity: 0.2,
    style: {
      transformOrigin: "240.115px 95.235px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M250,88.06a26.89,26.89,0,0,0-7,1.57c-5.17,1.7-7.55,2.47-7.55-.34a4.44,4.44,0,0,1,.35-1.68,9.07,9.07,0,0,1,4-4c3.41-2,5.31-1.5,5.79.69l9.32-8a5.46,5.46,0,0,0-5.41-4.15,14.51,14.51,0,0,0-5.82,1.36V67.85l-4.82,2.81L236,72.32V78c-6.53,4.76-10.61,11-10.61,17.68a9.9,9.9,0,0,0,.58,3.66c1.44,3.61,5.39,3.11,9.55,1.89,1.46-.44,2.88-.95,4.15-1.36,3-1,5.11-1.36,5.11,1.19,0,2.26-1.7,4.28-4.22,5.74-4,2.34-5.58.44-5.92-1.42l-9.8,8.3a8.8,8.8,0,0,0,.74,2c1.28,2.4,3.56,3,6.22,2.7a18.46,18.46,0,0,0,4.82-1.44v5.68l7.62-4.4v-5.72c6.6-4.86,11.15-11.41,11.15-18.27C255.39,89.35,253.05,88,250,88.06Z",
    fill: "#fff",
    style: {
      transformOrigin: "240.115px 95.235px"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "236 78.01 231.18 75.22 231.18 69.54 236 72.32",
    fill: "#1f1ff9",
    style: {
      transformOrigin: "233.59px 73.775px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M244.24,112.55,245,112c.24-.19.53-.42.84-.7s.69-.58,1.07-.94.8-.72,1.21-1.15l.64-.66.64-.7c.23-.24.44-.49.65-.75s.43-.51.64-.78c.41-.55.83-1.09,1.2-1.68s.73-1.17,1.08-1.75.63-1.19.88-1.79.46-1.19.68-1.74l.24-.83c0-.13.08-.27.11-.4l.09-.38a12.73,12.73,0,0,0,.26-1.39,10.91,10.91,0,0,0,.13-1.09l0-1,0,1a8,8,0,0,1-.09,1.1,12.11,12.11,0,0,1-.22,1.4l-.07.39c0,.14-.08.27-.11.4-.08.28-.15.56-.23.85-.21.56-.38,1.17-.66,1.76s-.56,1.2-.87,1.81-.68,1.21-1.08,1.78-.81,1.13-1.22,1.68c-.21.27-.44.52-.65.78s-.43.51-.65.75l-.66.7-.66.64c-.42.43-.85.79-1.24,1.14s-.76.64-1.09.91-.62.49-.87.67Z",
    fill: "#fff",
    style: {
      transformOrigin: "249.8px 103.41px"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-43",
    className: "animable",
    style: {
      transformOrigin: "289.835px 68.2718px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "c",
    className: "animable",
    style: {
      transformOrigin: "289.835px 68.2718px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    className: "animable",
    style: {
      transformOrigin: "289.835px 68.2718px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M318.69,36.32c-.07-.47-.46-.64-.92-.37L273.71,61.33a1.91,1.91,0,0,0-.66.69L269,59.67a1.85,1.85,0,0,1,.64-.66l44.06-25.38a2.09,2.09,0,0,1,1.87,0l2.21,1.26A2.1,2.1,0,0,1,318.69,36.32Z",
    fill: "#f0f0f0",
    style: {
      transformOrigin: "293.845px 47.7146px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m273.71 102.91a2.06 2.06 0 0 1-1.87 0l-2.22-1.27a2 2 0 0 1-0.93-1.6v-39.42a1.91 1.91 0 0 1 0.29-0.95l4.07 2.33a1.89 1.89 0 0 0-0.28 0.92v39.43c0 0.57 0.39 0.88 0.94 0.56z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "271.2px 81.4022px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M268.69,73.44l-7.5,7.62a.83.83,0,0,0,.14,1.28c.15.1,4.06,2.38,4.06,2.38l7.38-8.89Z",
    fill: "#f0f0f0",
    style: {
      transformOrigin: "266.86px 79.08px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M273.29,102.79c-.24,0-.27-.29-.27-.41V83.59l-7.09,1a.59.59,0,0,1-.6-.35.57.57,0,0,1,.12-.63l7.57-7.7v-13a1.82,1.82,0,0,1,.81-1.4l44.06-25.37a.56.56,0,0,1,.29-.1c.25,0,.27.29.27.42V75.92a1.82,1.82,0,0,1-.8,1.4L273.58,102.7a.6.6,0,0,1-.29.09Z",
    fill: "#fafafa",
    style: {
      transformOrigin: "291.866px 69.415px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M318.18,36.32a.42.42,0,0,1,0,.17V75.92a1.55,1.55,0,0,1-.69,1.19l-44.06,25.38c-.1.05-.16.06-.16.07a.36.36,0,0,1,0-.18V83.3l-.57.08-6.79,1h-.06a.32.32,0,0,1-.29-.21.31.31,0,0,1,.07-.36l7.5-7.62.14-.15V62.94a1.56,1.56,0,0,1,.68-1.18L318,36.38a.34.34,0,0,1,.16-.06m0-.5a.92.92,0,0,0-.42.13L273.71,61.33a2,2,0,0,0-.94,1.61V75.83l-7.49,7.63a.82.82,0,0,0,.57,1.4H266l6.79-1v18.51c0,.42.21.66.52.66a.84.84,0,0,0,.42-.13l44.06-25.37a2.08,2.08,0,0,0,.93-1.62V36.49c0-.42-.21-.67-.51-.67Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "291.88px 69.425px"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m279.93 69.25a1.23 1.23 0 0 1-0.62-2.3l32.1-18.54a1.23 1.23 0 1 1 1.23 2.14l-32.09 18.54a1.27 1.27 0 0 1-0.62 0.16z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "295.974px 58.7475px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m279.93 76.2a1.23 1.23 0 0 1-0.62-2.3l32.1-18.54a1.23 1.23 0 1 1 1.23 2.14l-32.09 18.5a1.27 1.27 0 0 1-0.62 0.2z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "295.974px 65.6975px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M279.93,83.15a1.23,1.23,0,0,1-.62-2.3l32.1-18.54a1.23,1.23,0,1,1,1.23,2.14L280.55,83A1.19,1.19,0,0,1,279.93,83.15Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "295.974px 72.6478px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m279.93 90.1a1.23 1.23 0 0 1-0.62-2.3l32.1-18.54a1.23 1.23 0 1 1 1.23 2.14l-32.09 18.53a1.19 1.19 0 0 1-0.62 0.17z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "295.974px 79.5975px"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    style: {
      transformOrigin: "130.328px 404.807px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "a",
    className: "animable",
    style: {
      transformOrigin: "177.443px 386.042px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M166.5,410.62c-3.07-6.21-4.64-17.65-3-28.51,1.39-9.13,7.47-17.57,14.2-20,2.79-1,5-.91,6.8.78,3.1,3,1,7.67-1.7,10.81-1.21,1.38-11.59,11.05-11,25.9l.77,7.51Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "174.441px 386.042px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M167.47,407.94a.33.33,0,0,0,.16-.35c-2.49-18.15.24-30.51,10.12-38.75a.31.31,0,0,0,0-.45.33.33,0,0,0-.46,0c-10.06,8.08-13,21.05-10.29,39.35a.31.31,0,0,0,.39.23A.11.11,0,0,0,167.47,407.94Z",
    fill: "#fff",
    style: {
      transformOrigin: "171.946px 388.14px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M174.19,406.18c.13-2.57,2-7.94,5.68-11.69,4.61-4.68,10-6.16,11.73-9.63s-1.76-7.32-7.14-5.77c-6.47,1.87-16.11,9.65-14.23,29.38Z",
    fill: "#ebebeb",
    style: {
      transformOrigin: "181.019px 393.603px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M171.74,404.77a.31.31,0,0,0,.22-.27c1.57-13.59,9-19.85,13.32-21.46a.32.32,0,0,0,.19-.41.31.31,0,0,0-.41-.19c-4.76,1.78-12.14,8.11-13.74,22a.33.33,0,0,0,.29.36A.29.29,0,0,0,171.74,404.77Z",
    fill: "#fff",
    style: {
      transformOrigin: "178.404px 393.609px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    style: {
      transformOrigin: "85.4164px 421.997px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m101.68 439.85-6.16 3.56c-0.35-18.06-12.07-31.29-17.72-38.28s2.2-11.39 8.89-8.26 12.13 11.13 14.37 21.55c1.94 8.9 0.94 18.76 0.62 21.43z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "89.0427px 419.627px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M99.06,439.3h.08a.39.39,0,0,0,.38-.41c-.62-22.73-8.19-34.12-16.94-39.91a.4.4,0,0,0-.44.66c8.63,5.71,16,16.86,16.6,39.28A.38.38,0,0,0,99.06,439.3Z",
    fill: "#fff",
    style: {
      transformOrigin: "90.7619px 419.119px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M68.61,419.26a5,5,0,0,0,2.12,3A5.85,5.85,0,0,1,73,425.22c.53,2.49-2.43,4.79-1.79,7.26a4,4,0,0,0,2.09,2.33,26.28,26.28,0,0,0,2.44,1,9.18,9.18,0,0,0,1.23.3,5.73,5.73,0,0,1,3.36,1.5c1.36,1.48,1.19,3.76,1.67,5.71.58,2.34,2,3.71,5.16,4.83L98.09,442c2.72-2.77,3.67-7.5,1.17-10.72-1.5-1.94-4.32-2.18-5.73-4.11-1.28-1.74-.54-4.24-1.32-6.24s-2.86-2.7-4.81-3-4,.47-6-.23-3.68-1.82-5.66-2.32a6.61,6.61,0,0,0-5.71,1A3.51,3.51,0,0,0,68.61,419.26Z",
    fill: "#ebebeb",
    style: {
      transformOrigin: "84.6605px 431.636px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M88.94,429.1a.2.2,0,0,0-.08-.12C83.73,421.72,75.7,418.26,73,417.66a.28.28,0,0,0-.34.21.28.28,0,0,0,.22.34,30.21,30.21,0,0,1,15,10.43,15.64,15.64,0,0,0-12.5,1.09.29.29,0,0,0-.09.39.29.29,0,0,0,.23.13.33.33,0,0,0,.17,0,15.09,15.09,0,0,1,12.77-.77,23.77,23.77,0,0,1,4.27,14.66.28.28,0,0,0,.25.29h0a.27.27,0,0,0,.29-.27A24.26,24.26,0,0,0,88.94,429.1Z",
    fill: "#fff",
    style: {
      transformOrigin: "82.9757px 431.041px"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    style: {
      transformOrigin: "134.255px 384.46px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    className: "animable",
    style: {
      transformOrigin: "155.945px 371.935px"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "178.93 355.37 159.49 328.47 152.4 324.39 132.96 373.74 140.04 377.82 144.07 375.5 144.07 415.4 144.08 415.39 151.15 419.47 151.15 419.48 151.16 419.48 167.82 409.86 167.82 361.79",
    fill: "#1f1ff9",
    style: {
      transformOrigin: "155.945px 371.935px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "140.04 377.82 159.49 328.47 178.93 355.37 167.82 361.79 167.82 409.86 151.16 419.48 151.15 419.48 151.15 371.41",
    fill: "#1f1ff9",
    style: {
      transformOrigin: "159.485px 373.975px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "140.04 377.82 159.49 328.47 178.93 355.37 167.82 361.79 167.82 409.86 151.16 419.48 151.15 419.48 151.15 371.41",
    opacity: 0.3,
    style: {
      transformOrigin: "159.485px 373.975px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "159.49 328.47 152.4 324.39 132.96 373.74 140.04 377.82",
    opacity: 0.15,
    style: {
      transformOrigin: "146.225px 351.105px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "140.04 377.82 151.15 371.41 151.15 419.48 144.07 415.4 144.07 375.5",
    opacity: 0.45,
    style: {
      transformOrigin: "145.595px 395.445px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    style: {
      transformOrigin: "112.565px 406.615px"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "135.55 399.69 116.11 372.79 109.03 368.7 89.58 418.06 96.67 422.14 100.69 419.81 100.69 440.44 100.7 440.44 107.78 444.51 107.78 444.53 107.79 444.52 124.44 434.9 124.44 406.1",
    fill: "#1f1ff9",
    style: {
      transformOrigin: "112.565px 406.615px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "96.67 422.14 116.11 372.79 135.55 399.69 124.44 406.1 124.44 434.9 107.79 444.52 107.78 444.53 107.78 415.73",
    fill: "#1f1ff9",
    style: {
      transformOrigin: "116.11px 408.66px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "96.67 422.14 116.11 372.79 135.55 399.69 124.44 406.1 124.44 434.9 107.79 444.52 107.78 444.53 107.78 415.73",
    fill: "#fff",
    opacity: 0.3,
    style: {
      transformOrigin: "116.11px 408.66px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "116.11 372.79 109.03 368.7 89.58 418.06 96.67 422.14",
    fill: "#fff",
    opacity: 0.55,
    style: {
      transformOrigin: "102.845px 395.42px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "96.67 422.14 107.78 415.73 107.78 444.53 100.69 440.44 100.69 419.81",
    fill: "#fff",
    opacity: 0.1,
    style: {
      transformOrigin: "102.225px 430.13px"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    style: {
      transformOrigin: "401.209px 192.362px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    className: "animable",
    style: {
      transformOrigin: "401.209px 192.362px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    className: "animable",
    style: {
      transformOrigin: "409.203px 240.246px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M442.76,294.82c.32,1.91.93,4.13,1.4,8s-.37,4.05,2,13.86c1.41,5.89.91,7.56-2.1,12.81-3.25,5.66-8.85,4.32-11.35-1.6-2.13-5.06-1.51-7.39-1.42-12.58s.08-6.71-.07-10.83c-.14-3.64.22-6.11.05-8.9Z",
    fill: "#37474f",
    style: {
      transformOrigin: "439.025px 313.961px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m443.66 309.07c-0.62-5.05-0.68-10.26-0.87-13.67-0.43-7.63 1.43-22.66 0.57-34.15l-19.28-2.35c0.56 4.48 5.49 24.8 7.18 37 0 0 0.42 16.57 1.33 23.88a1.41 1.41 0 0 0 1.94 1.13 12.71 12.71 0 0 1 8.76-0.39 1.39 1.39 0 0 0 1.89-1.29c0.01-2.66-1.06-6.37-1.52-10.16z",
    fill: "#c8856a",
    style: {
      transformOrigin: "434.63px 289.959px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M389,260.11c-.79,16.27-.81,28.92-1.61,33.1a47.47,47.47,0,0,1-3.26,10.25c-1.24,2.89-3.25,6.72-5,8.54,0,0-4.91,4.71-3.9,5.28s10.68,2.11,15.11,1,5.09-4.75,6.93-11.43S401.53,291,401.53,291a7.16,7.16,0,0,1-.63-2.15c-.14-2.31,2-9.52,2.71-14.4Z",
    fill: "#c8856a",
    style: {
      transformOrigin: "389.352px 289.391px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m404.29 300.56c-0.22 2.2-1.66 3.35-2.28 5.81a43.56 43.56 0 0 0-1.32 8.54l-0.24 4-1.1-0.07s0.31-5.09 0.45-7.32 0-3.88-1-4.18c-0.04 0.02 0.2-7.1 5.49-6.78z",
    fill: "#263238",
    style: {
      transformOrigin: "401.543px 309.73px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m401.35 289.86a44.77 44.77 0 0 0 2.25 6.06 8.49 8.49 0 0 1 0.85 3.49 3.54 3.54 0 0 1-1.26 2.84 19.88 19.88 0 0 0-2.64 2.73c-1.43 1.71-4.15 5.75-5 8.66s-1.38 5.49-4 6.82c-2 1-10.22 2.2-14.33 2.24-5.61 0.06-6.92-2.71-4.71-4.74s6-5.53 6.62-6a10.25 10.25 0 0 1 5.16 1c3.06 1.52 4 3.39 7.34 1.92 3.06-1.33 4.14-6.79 4.7-14.71 0.88-12.17 5.02-10.31 5.02-10.31z",
    fill: "#37474f",
    style: {
      transformOrigin: "387.972px 306.229px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M432,147.39c1.13,2.44,3.31,5.14,5.55,9.86s5,9.84,5,21.87c.09,27.39-.85,53.75-.85,53.75.19,2.42,2,8.27,2.27,22,.21,11-.9,37.09-.9,37.09a15.52,15.52,0,0,1-12.79,1.06c-1.82-11.35-8.7-44.61-11.34-56.6-2.79-12.65-5.63-27.72-5.63-27.72l-4.73,22.06a64,64,0,0,1-.18,14.26c-.88,7.33-6.47,42.39-6.47,42.39s-7.62,2.73-15-1.18c0,0,0-46.09-.51-54.14-.47-7.84.44-63,6.12-83.23C401.61,153.9,424.25,152.53,432,147.39Z",
    fill: "#263238",
    style: {
      transformOrigin: "415.155px 220.658px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m413.33 208.75-2.53-23.08s-9.51-0.63-15.59-6.63c0 0 2.75 7.12 12.78 9.61l3.24 21.27-2.63 20.89z",
    style: {
      transformOrigin: "404.27px 204.925px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    style: {
      transformOrigin: "401.209px 124.475px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    className: "animable",
    style: {
      transformOrigin: "373.343px 108.901px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M400.68,96.23c-5.72,0-10.95,4.75-17.57,13.89-4.48,6.17-8,10.66-8,10.66s-11.49-15-12.24-17.56c-.9-3,0-5.2-.35-8.58s-1.1-5.53-.68-7.1-2.36-1.17-3,.81-.14,4.4-1,4.17-2.76-6.7-3.1-10.56-2.66-4.27-3.1-2.89a8.21,8.21,0,0,0-.27,1.9,1.84,1.84,0,0,0-2.4,1.19c-.16.45-.35,1.33-.35,1.33a2.63,2.63,0,0,0-1.91,2.11,4.73,4.73,0,0,1-.48,1.43c-.7,1.22-.55,3.2-.48,4.22a48.13,48.13,0,0,0,1,5.89,18.88,18.88,0,0,0,1.51,4.19c1.07,1.72,3.5,4.91,5.64,7.84.56.77,1.44,2.56,4,8.29,3,6.55,5.73,13.34,10.68,19.39,4.15,5.07,10.25,0,13.9-3.36,5.21-4.75,14.61-13.7,14.61-13.7C401.63,109.74,400.68,96.23,400.68,96.23Z",
    fill: "#c8856a",
    style: {
      transformOrigin: "373.225px 108.672px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M401,95.87c-6-.64-9.45,3-12.94,7.08s-13,17.14-13,17.14l-2.64-2.91a9.26,9.26,0,0,1-3.56,6.77c-3.67,3.15-6.89,2.27-6.89,2.27a56.14,56.14,0,0,0,4.17,8c2.56,4,4.81,5.48,8,5.2s5.43-2.24,11.95-8.48,11.69-11.81,11.69-11.81Z",
    fill: "#37474f",
    style: {
      transformOrigin: "381.485px 117.625px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m357.06 93.94a8.22 8.22 0 0 0-1.09 9.5s-2.35-2.91-1.66-5.91a4.62 4.62 0 0 1 2.75-3.59z",
    fill: "#af6152",
    style: {
      transformOrigin: "355.622px 98.69px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m375 120.09s2.94 3 4.1 9.54a13.83 13.83 0 0 0-3-10.94z",
    fill: "#263238",
    style: {
      transformOrigin: "377.133px 124.16px"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M437.14,126.56c-8.21-4.94-6.06-19.66-4.56-27.17,0,0-3.36-1.55-15-2.57-10.52-.92-15-.41-15-.41-1.73,1.49-5.65,5-12.63,15.27-3.44,5.07-4.82,11.29.88,19l1.05,7.89c.5,6.25-2.28,10.91-.12,13.41,1.26,1.48,8.41,5.33,22.09,5.2,13.45-.13,18.93-4.32,20.48-5.69,2.39-2.32.35-8.14.62-11.41A57.69,57.69,0,0,1,437.14,126.56Z",
    fill: "#455a64",
    style: {
      transformOrigin: "412.05px 126.726px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M430.67,99c7.33,1.08,11.75,3,14.06,9.06s9.12,26.67,10.51,31,1,6.21-.85,10.46q-1.74,4-3.44,8c-1.51,3.55-4.1,9.46-4.61,10.87a12.23,12.23,0,0,0-1,4.5,28.31,28.31,0,0,1-.17,4.78,20,20,0,0,1-1.52,5.46c-.53,1.21-.88,2.53-1.48,3.69a14.11,14.11,0,0,1-1.82,2.19c-.67.81-.93,1.85-1.74,2.56-1.41,1.24-2.86,1.37-4.19,1.93-.59.8-1.6,2.49-2.26,3.24-1.68,1.9-1.95-1.32-1.85-2.4a15.53,15.53,0,0,1,.77-3.42,78.12,78.12,0,0,0,2.27-8.49c.11-.51.8-2.61-.06-2.63a1,1,0,0,0-.71.38,24,24,0,0,0-1.58,2.13,14.34,14.34,0,0,1-1.43,1.49,4.63,4.63,0,0,1-1.43,1c-.56.21-2.6.3-2.66-.64a1,1,0,0,1,.12-.44c.45-1,1-1.86,1.44-2.82a25.8,25.8,0,0,0,1.28-2.9,23.88,23.88,0,0,1,3.91-8.23c3.6-4.56,8.41-27.22,8.41-27.22l-6.22-16.79a31.37,31.37,0,0,1-5.59-15.56C428.41,101.5,430.67,99,430.67,99Z",
    fill: "#c8856a",
    style: {
      transformOrigin: "440.777px 148.164px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m430.67 98.78c3.63 0.42 8.64 1 11.45 4.27s3.62 4.15 7.47 15.48 6.55 19.67 6.88 21.26 0.9 2.54-2.31 10.25c0 0-1.53-1.95-6.15-3.28a18.43 18.43 0 0 0-8.2-0.56l0.44-2.68-6.86-18a31.15 31.15 0 0 1-4.93-16.74c0-7.78 2.21-10 2.21-10z",
    fill: "#37474f",
    style: {
      transformOrigin: "442.596px 124.41px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m439.81 146.2-1.64 6.8c4.43-0.06 9.38 1.18 12.92 4.15l3.07-7.15s-0.6-1.63-5.84-3.26-8.51-0.54-8.51-0.54z",
    fill: "#455a64",
    style: {
      transformOrigin: "446.165px 151.497px"
    }
  }), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    style: {
      transformOrigin: "414.387px 78.0876px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m408.75 84.35a16.06 16.06 0 0 0-2.53-4.28 22.93 22.93 0 0 0-4.05-2.68c-1.44-1-2.9-1.88-4.32-2.86-4.18-2.86-3.69-9.33-2.29-12.9 2.35-6 9.74-9.87 16.16-10 10.25-0.18 14.65 3 15.53 8.31 2.45 0.22 3.68 1.41 5 3 2.65 3.33 2.2 9 1.11 13.1-1.53 5.82-4 7.1-6.07 9.33a19.06 19.06 0 0 0-3.81 6.25s-13.24-4.29-14.73-7.27z",
    fill: "#455a64",
    style: {
      transformOrigin: "414.387px 71.6214px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M426.24,84.59a4.72,4.72,0,0,0,4.42-1.82c2.46-2.75,2.68-5.53,1.51-7.38-1-1.51-3.31-2.47-4.95-1.43s-1.8,2-2.45,3.26-3.23,1.15-3.87-3.86c-.6-4.68-.34-9-2.65-11.07-3.44-3.13-7.12-1.58-9.59.29-1.41-2.18-3.37-3.37-5.7-2.1s-5.11,4.57-5.37,13c-.29,9.09.32,14.36,3.6,17,1.53,1.21,3.59,1.38,7,1.51l-.28,4.34s-3.7,7.17,2.13,8.09c7.93,1.26,13-6.88,13-6.88l1-14.3A2.89,2.89,0,0,0,426.24,84.59Z",
    fill: "#c8856a",
    style: {
      transformOrigin: "415.191px 82.256px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m428.45 82.23a1.2 1.2 0 1 1-1.2-1.2 1.19 1.19 0 0 1 1.2 1.2z",
    fill: "#fafafa",
    style: {
      transformOrigin: "427.25px 82.23px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m408.66 62.58s1.4-3.22 6.26-3.81a7.24 7.24 0 0 1 8.14 5c0.79 2.45 0 9.2 0.66 10.9a2.8 2.8 0 0 0 3.53 1.73c-2.38 2.37-4.89 2.35-6.71 0.65s-1.83-5.12-2.23-9.37c-0.42-4.48-4.6-7.58-9.65-5.1z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "417.955px 68.4633px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M417.41,72.29a.34.34,0,0,0-.26,0l-.23,0-.46.12-.45.14-.23.07-.1,0a.26.26,0,0,0-.09.09s-.06.11,0,.14.05,0,.09,0h.1l.23,0,.45-.05.48,0,.24,0h.1a.23.23,0,0,0,.14-.09C417.51,72.63,417.54,72.36,417.41,72.29Z",
    fill: "#af6152",
    style: {
      transformOrigin: "416.53px 72.5637px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m417.52 73.76c-0.08-0.15-0.27-0.11-0.42-0.12h-0.5-0.93l0.91 0.19 0.42 0.17 0.24 0.05a0.19 0.19 0 0 0 0.22-0.05 0.22 0.22 0 0 0 0.06-0.24z",
    fill: "#af6152",
    style: {
      transformOrigin: "416.602px 73.8529px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M398.82,71.45a.38.38,0,0,1,.25,0,1.89,1.89,0,0,1,.21.09l.43.22.41.23.2.12.1.06a.39.39,0,0,1,.06.11s0,.13,0,.15-.06,0-.1,0l-.1,0-.21-.08-.43-.15-.46-.15-.23-.08-.1,0a.29.29,0,0,1-.11-.11C398.65,71.76,398.67,71.49,398.82,71.45Z",
    fill: "#af6152",
    style: {
      transformOrigin: "399.583px 71.9339px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M398.38,72.86c.11-.12.29,0,.44,0l.48.09.91.23s0,0,0,0h-1.64a.2.2,0,0,1-.2-.1A.21.21,0,0,1,398.38,72.86Z",
    fill: "#af6152",
    style: {
      transformOrigin: "399.277px 72.9942px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m411.79 73.73a1.6 1.6 0 0 0 1.88 0.78 1.18 1.18 0 0 0 1-1.52 1.6 1.6 0 0 0-1.88-0.78 1.18 1.18 0 0 0-1 1.52z",
    fill: "#263238",
    style: {
      transformOrigin: "413.23px 73.36px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m400.32 69.35 3.4-1.09a1.72 1.72 0 0 0-2.19-1.19 1.88 1.88 0 0 0-1.21 2.28z",
    fill: "#263238",
    style: {
      transformOrigin: "401.986px 68.1683px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M403.9,73.31A1.56,1.56,0,0,1,402,74a1.19,1.19,0,0,1-.92-1.56,1.6,1.6,0,0,1,1.91-.72A1.19,1.19,0,0,1,403.9,73.31Z",
    fill: "#263238",
    style: {
      transformOrigin: "402.495px 72.8655px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m412.88 68.69 3.55 1.43a1.84 1.84 0 0 0-1-2.48 2 2 0 0 0-2.55 1.05z",
    fill: "#263238",
    style: {
      transformOrigin: "414.739px 68.8123px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m413 81.64-5 1.43a2.59 2.59 0 0 0 3.44 1.69 2.42 2.42 0 0 0 1.56-3.12z",
    fill: "#af6152",
    style: {
      transformOrigin: "410.57px 83.2906px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m410 84.86a2.72 2.72 0 0 1 2.8-2.33h0.25a2.28 2.28 0 0 1-1.63 2.19 2.9 2.9 0 0 1-1.42 0.14z",
    fill: "#f28f8f",
    style: {
      transformOrigin: "411.525px 83.7103px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m408.77 71-1.38 8.48-4.39-1.48a14.79 14.79 0 0 1 5.77-7z",
    fill: "#af6152",
    style: {
      transformOrigin: "405.885px 75.24px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M408.17,91.93a32,32,0,0,0,9.66-1.85c1.13-.45,2.68-2.45,4-4.68,0,0-1,4.44-3.42,5.92-3.72,2.24-10.32,2.56-10.32,2.56Z",
    fill: "#af6152",
    style: {
      transformOrigin: "414.96px 89.64px"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m437.14 99.76c-1.23 4.28 0 45.94 0 45.94a28.38 28.38 0 0 1-12.64 3.79c-7.27 0.36-11.43-1.29-11.43-1.29s0.1-20.29 1.64-28.25c3.24-16.74 12.54-22.41 12.54-22.41a65.79 65.79 0 0 0 9.89 2.22z",
    fill: "#1f1ff9",
    style: {
      transformOrigin: "425.105px 123.541px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m437.14 99.76c-1.23 4.28 0 45.94 0 45.94a28.38 28.38 0 0 1-12.64 3.79c-7.27 0.36-11.43-1.29-11.43-1.29s0.1-20.29 1.64-28.25c3.24-16.74 12.54-22.41 12.54-22.41a65.79 65.79 0 0 0 9.89 2.22z",
    fill: "#fff",
    opacity: 0.45,
    style: {
      transformOrigin: "425.105px 123.541px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m414.71 120a77.49 77.49 0 0 0-0.95 8.44c6-0.88 11.28-5.17 14.46-9.81 3.57-5.19 6.22-13.89 6.63-19.18-2.49-0.45-5-1.13-7.6-1.86 0-0.05-9.25 5.62-12.54 22.41z",
    fill: "#1f1ff9",
    opacity: 0.4,
    style: {
      transformOrigin: "424.305px 113.015px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m408 94.6-0.11 1.67s-0.89 3.73 2.11 4.79 9.37-0.22 13.08-4.3l0.14-2.16a2.9 2.9 0 0 1 2.25 1.1c0.71 1.1 9.36 3.69 9.36 3.69s-6.63 27.8-29 26.56-11.46-22.78-4.83-30.08a11.5 11.5 0 0 0 3.43-0.09c1.71-0.25 2.24-1.16 3.57-1.18z",
    fill: "#1f1ff9",
    style: {
      transformOrigin: "413.628px 110.295px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m408 94.6-0.11 1.67s-0.89 3.73 2.11 4.79 9.37-0.22 13.08-4.3l0.14-2.16a2.9 2.9 0 0 1 2.25 1.1c0.71 1.1 9.36 3.69 9.36 3.69s-6.63 27.8-29 26.56-11.46-22.78-4.83-30.08a11.5 11.5 0 0 0 3.43-0.09c1.71-0.25 2.24-1.16 3.57-1.18z",
    fill: "#fff",
    opacity: 0.55,
    style: {
      transformOrigin: "413.628px 110.295px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M403.78,122.25a13.11,13.11,0,0,1-4.07-1.91,6.82,6.82,0,0,1-2.63-3.42,11.11,11.11,0,0,1-.36-4.43,26.89,26.89,0,0,1,.83-4.51,36.48,36.48,0,0,1,1.47-4.39,31,31,0,0,1,2-4.21,30,30,0,0,0-4.12,8.4,23.48,23.48,0,0,0-1,4.63,11.86,11.86,0,0,0,.35,4.8,7.72,7.72,0,0,0,3,3.84,13,13,0,0,0,4.4,1.88,15,15,0,0,0,9.28-.64,13.93,13.93,0,0,1-4.57.61A17.22,17.22,0,0,1,403.78,122.25Zm-.21-15.51.31.56a5,5,0,0,0,.76,1,6.75,6.75,0,0,0,1,.76,5,5,0,0,0,1.15.48,8.62,8.62,0,0,0,4.73-.16,11.18,11.18,0,0,1-4.5-.52,4.48,4.48,0,0,1-2.8-3,9.32,9.32,0,0,1-.12-4.4A27.25,27.25,0,0,1,405.39,97a15.13,15.13,0,0,0-2,4.3,8.71,8.71,0,0,0-.05,4.83Zm23.76,2.9a51.83,51.83,0,0,1-6.55,8.22,26.85,26.85,0,0,0,7.32-7.73,29.62,29.62,0,0,0,3.85-9.94A63.14,63.14,0,0,1,427.33,109.64Zm-1.84-13.13a17.45,17.45,0,0,1-1.33,3.88,35.61,35.61,0,0,1-1.84,3.65,29.37,29.37,0,0,1-4.89,6.47,14.86,14.86,0,0,1-6.82,4,12.26,12.26,0,0,1-4,.29,17.93,17.93,0,0,1-4-.88,15.64,15.64,0,0,0,3.94,1.33,12.6,12.6,0,0,0,4.2-.05,14.35,14.35,0,0,0,7.32-4.07,25.74,25.74,0,0,0,4.86-6.79A22.4,22.4,0,0,0,425.49,96.51ZM409,104.34a11.36,11.36,0,0,0,5.86.42,13.55,13.55,0,0,0,5.41-2.25,18.22,18.22,0,0,0,2.22-1.88,16.21,16.21,0,0,0,1.81-2.25,22.43,22.43,0,0,1-2.11,1.92,18.43,18.43,0,0,1-2.31,1.62,15.21,15.21,0,0,1-5.17,1.93,14.21,14.21,0,0,1-2.76.22,9.33,9.33,0,0,1-2.7-.39,3.39,3.39,0,0,1-2-1.58,4.46,4.46,0,0,1-.36-2.72,4.24,4.24,0,0,0,0,2.9A3.89,3.89,0,0,0,409,104.34Z",
    fill: "#1f1ff9",
    opacity: 0.4,
    style: {
      transformOrigin: "413.874px 109.947px"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    style: {
      transformOrigin: "315.343px 299.717px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    className: "animable",
    style: {
      transformOrigin: "315.343px 299.717px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M365.76,410.36c0,1.38.26,1.91-1.43,3.16s-5.36,1.82-8.15,1.06a7.48,7.48,0,0,1-4.5-2.71,38.38,38.38,0,0,1-2.61-3.94c-.49-.63-2.76-1.82-4.95-2.79s-6.71-3.06-8.29-6.8a8.82,8.82,0,0,1-.49-6.41Z",
    fill: "#263238",
    style: {
      transformOrigin: "350.364px 403.426px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m351 391.39c4.46 2.91 8.21 10.23 14.31 8 0.31 3.59 1.26 7.45 0.41 11-2.6 3.21-8.29 3.83-11.57 1.51-1.65-1.4-2.58-3.05-4.17-4.54a16.16 16.16 0 0 0-4.39-2.67 46.9 46.9 0 0 1-5.31-2.94c-9.81-7.3-4.92-20.61 10.72-10.36z",
    fill: "#37474f",
    style: {
      transformOrigin: "350.639px 400.474px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m335.32 431.22c0 1.5-0.1 2.62-1 3.25s-7.75 1.76-9.57 2-2.08-1-3.35-0.56-4.25 2.6-8.71 3.59-8.11 2-14.3 0-6.79-4.44-6.71-6.53 43.64-1.75 43.64-1.75z",
    fill: "#263238",
    style: {
      transformOrigin: "313.497px 435.926px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m334.42 417.26c1 4.28 2.06 10.7 0.9 14-1.25 1.24-5.43 2-9.07 2.46a28.09 28.09 0 0 0-9.65 3c-7.07 2.95-19.51 4-24.47-2.63-4.94-8.89 20.81-6.71 24-17 1.12-3.78 13.62 1.18 18.29 0.17z",
    fill: "#37474f",
    style: {
      transformOrigin: "313.665px 427.335px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m367.74 362.59c-3.45-36.59-2.74-66.59-3.89-95.79 0 0-50.38-5.35-51.65 12.08s-0.92 66.84-0.52 74.52c0.18 7.78 3 60.4 3 65.89 12.75 6.32 20.66 1.54 20.66 1.54-0.08-7.08 5.45-38.69 2.45-55.95l2-33.66s8.75 56.84 10.23 71c3.76 5.58 14.45 4.28 16.23 0.91 0.02-0.01 2.69-29.78 1.49-40.54z",
    fill: "#455a64",
    style: {
      transformOrigin: "339.681px 344.294px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M339.81,331.22l2.87-24.5A27.13,27.13,0,0,0,356.8,298c-1.53,5.59-6.84,9.57-10.68,10.93L342.05,330l1.59,26.5Z",
    fill: "#37474f",
    style: {
      transformOrigin: "348.305px 327.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m346.64 325.68c0.6 9.68 1.23 19.69 2.07 24.41 1.32 7.37 5.05 46.16 5.92 55.34a8.82 8.82 0 0 1-0.86-0.31c-0.94-9.83-4.57-47.64-5.87-54.88-0.86-4.77-1.48-14.81-2.09-24.51-0.46-7.3-0.89-14.2-1.37-17.78l0.82-0.11c0.49 3.61 0.92 10.52 1.38 17.84z",
    fill: "#37474f",
    style: {
      transformOrigin: "349.535px 356.635px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M321.14,421.73c-1.1-16.55-3.75-58.23-3.53-75,.25-20,.92-55.45,2.54-68.37l.82.1c-1.61,12.88-2.28,48.31-2.54,68.28-.21,16.81,2.46,58.81,3.55,75.17Z",
    fill: "#37474f",
    style: {
      transformOrigin: "319.789px 350.135px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m318.58 308.87 0.42-0.71c-6.33-3.73-5.58-14.76-5.14-21.35 0-0.49 0.07-1 0.09-1.41h-0.82q0 0.66-0.09 1.41c-0.46 6.73-1.23 18.07 5.54 22.06z",
    fill: "#37474f",
    style: {
      transformOrigin: "315.876px 297.135px"
    }
  }), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    style: {
      transformOrigin: "315.343px 227.186px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m363.91 212.82c5.1 2.4 7 5.79 8.73 14.88s4 27.64 3.87 32.06-3.09 7-7.86 6.26-13.4-1.34-13.4-1.34z",
    fill: "#263238",
    style: {
      transformOrigin: "365.883px 239.483px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M364.15,212.94a159.84,159.84,0,0,0-16.79-6.79c-.56,2.63-9.49,6.21-16.38,4.81-2.05.61-11.91,4.9-12.48,5.28-5.76,3.91-6.31,10.47-6.78,28.31s-.09,46.7-.09,46.7c8.79,4.28,24.78,5,34.26,3.85,8.23-1,15-4.1,18.52-7.83,0,0-.81-15.08-.47-25.23.23-6.6.71-9.74,1.54-21.59C366.51,225.75,367.4,217,364.15,212.94Z",
    fill: "#37474f",
    style: {
      transformOrigin: "338.955px 250.87px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "332.65 203.35 333.1 211.32 349.5 209.98 348.97 194.87",
    fill: "#ffa8a7",
    style: {
      transformOrigin: "341.075px 203.095px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M333,207.63s5.81,2.25,10.89,1.83c5.78-.48,5.54-3,5.54-3l0-1.16s.91,0,1.48,1.27c.84,1.83,1.39,3.43,1.39,3.43s1,3.32-4.94,4.86c-8.52,2.22-18.7-2.92-18.7-2.92l-1.82.66s3.29-4.51,4.74-5.59a2.51,2.51,0,0,1,1.36-.64Z",
    fill: "#263238",
    style: {
      transformOrigin: "339.602px 210.358px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m322 183.06s-4.06 5.65-3.64 6.24 3.2 1.21 3.2 1.21z",
    fill: "#f28f8f",
    style: {
      transformOrigin: "320.165px 186.785px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m323.69 186.86a4.56 4.56 0 1 1 4.74-4.37 4.57 4.57 0 0 1-4.74 4.37zm0.32-8.1a3.55 3.55 0 1 0 3.4 3.69 3.55 3.55 0 0 0-3.41-3.69z",
    fill: "#263238",
    style: {
      transformOrigin: "323.874px 182.304px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m333.93 167.44c-7.8 1.32-11 4.76-12.25 17-1.28 12.81 0.72 16.77 2.34 18.56 1.09 1.22 7.41 1.68 10.64 0.93 4-0.94 13.2-3.78 17.69-10.07 5.29-7.4 7-17.65 1.85-22.09-7.26-6.22-17.09-4.87-20.27-4.33z",
    fill: "#ffa8a7",
    style: {
      transformOrigin: "339.287px 185.613px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m332.72 204.25-0.26-2.39a15.27 15.27 0 0 1-8 1.48c1.44 0.79 5.28 1.15 8.26 0.91z",
    fill: "#f28f8f",
    style: {
      transformOrigin: "328.59px 203.092px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "319.87 181.19 333.56 183.52 332.96 184.47 319.83 182.22",
    fill: "#263238",
    style: {
      transformOrigin: "326.695px 182.83px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M320.16,170.91a4.05,4.05,0,0,0-.7,2.17,3.63,3.63,0,0,0,1.84,3.25,3.15,3.15,0,0,0,3.63-.52,4.05,4.05,0,0,0,1.16,3.65,2.87,2.87,0,0,0,3.66.14c-.29.7-.51,1.66.11,2.09a1.27,1.27,0,0,0,.53.2,2.7,2.7,0,0,0,1.61-.2,2.6,2.6,0,0,0-.56,2.31c.09.26,1.49,1.83,1.55,1.63,0,0,1.41-4.7,5.39-3.94s4.34,5.92,1.68,8.94-4.95,1.74-5,1.72c.07.83.21,5.29,4,7.66,2.34,1.44,6.53,2.82,10.09,1.53,2.38-1,4-3.72,6.34-7.42a46.73,46.73,0,0,0,4.35-10c1.13-4,1.26-5.92.43-8.83a7.3,7.3,0,0,0-5.4-5.26c-.28-2.82-.81-5-4-7.4-5-3.82-10.5-3.86-14.75-3.43a24.17,24.17,0,0,1-4.39.37c-1.27-.11-2.49-.56-3.75-.71a4,4,0,0,0-3.51,1,4.09,4.09,0,0,0-.36,3.84,6.29,6.29,0,0,0-2.89,1,3.52,3.52,0,0,0-1.53,2.56,2.42,2.42,0,0,0,1.53,2.43A4.41,4.41,0,0,0,320.16,170.91Z",
    fill: "#263238",
    style: {
      transformOrigin: "340.132px 180.418px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M332.8,188.34l.36-5.37a2.69,2.69,0,1,0-.36,5.37Z",
    fill: "#263238",
    style: {
      transformOrigin: "331.724px 185.652px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m281.67 191.48-25.07 13.08a3.16 3.16 0 0 0-1.47 3.78l13 35.49a2.21 2.21 0 0 0 3.27 1.22l23.16-13a3.45 3.45 0 0 0 1.54-3.89l-11.23-35.36a2.18 2.18 0 0 0-3.2-1.32z",
    fill: "#455a64",
    style: {
      transformOrigin: "275.596px 218.282px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M281.1,195l-21.86,11.41a2.08,2.08,0,0,0-1,2.51l11.86,31.5a1.5,1.5,0,0,0,2.2.81l20.24-11.34a2.27,2.27,0,0,0,1-2.58l-10.33-31.43A1.47,1.47,0,0,0,281.1,195Z",
    fill: "#fff",
    style: {
      transformOrigin: "275.881px 218.135px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M261.32,209.49a.37.37,0,0,1-.17-.7l20.32-10.6a.36.36,0,0,1,.5.16.37.37,0,0,1-.15.5l-20.33,10.6A.33.33,0,0,1,261.32,209.49Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "271.481px 203.817px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M262.26,212.14a.35.35,0,0,1-.33-.2.37.37,0,0,1,.15-.5l20.33-10.6a.37.37,0,0,1,.5.15.38.38,0,0,1-.16.5L262.43,212.1A.38.38,0,0,1,262.26,212.14Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "272.417px 206.468px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M263.19,214.79a.4.4,0,0,1-.33-.2.38.38,0,0,1,.16-.5l20.32-10.61a.38.38,0,0,1,.5.16.37.37,0,0,1-.15.5l-20.33,10.6A.34.34,0,0,1,263.19,214.79Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "273.353px 209.116px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M264.13,217.43a.35.35,0,0,1-.33-.2.37.37,0,0,1,.15-.5l20.33-10.6a.37.37,0,0,1,.5.15.37.37,0,0,1-.16.5L264.3,217.39A.38.38,0,0,1,264.13,217.43Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "274.289px 211.758px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M265.06,220.08a.37.37,0,0,1-.17-.7l20.32-10.61a.38.38,0,0,1,.5.16.36.36,0,0,1-.16.5L265.23,220A.47.47,0,0,1,265.06,220.08Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "275.221px 214.406px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M266,222.72a.35.35,0,0,1-.33-.2.37.37,0,0,1,.15-.5l20.33-10.6a.36.36,0,0,1,.5.16.38.38,0,0,1-.16.5l-20.32,10.6A.38.38,0,0,1,266,222.72Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "276.157px 217.047px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M266.93,225.37a.37.37,0,0,1-.17-.7l20.32-10.6a.36.36,0,0,1,.5.15.36.36,0,0,1-.16.5L267.1,225.33A.33.33,0,0,1,266.93,225.37Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "277.091px 219.696px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M267.86,228a.37.37,0,0,1-.32-.2.36.36,0,0,1,.15-.5L288,216.71a.37.37,0,0,1,.5.16.37.37,0,0,1-.15.5L268,228A.41.41,0,0,1,267.86,228Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "278.018px 222.337px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M268.8,230.66a.38.38,0,0,1-.33-.2.36.36,0,0,1,.16-.5L289,219.36a.37.37,0,1,1,.34.65L269,230.62A.33.33,0,0,1,268.8,230.66Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "279.004px 224.977px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M269.73,233.31a.37.37,0,0,1-.17-.7L289.88,222a.37.37,0,0,1,.5.16.36.36,0,0,1-.15.5l-20.32,10.61A.58.58,0,0,1,269.73,233.31Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "279.892px 227.634px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M270.67,236a.37.37,0,0,1-.17-.7l20.32-10.6a.36.36,0,0,1,.5.16.38.38,0,0,1-.16.5l-20.32,10.6A.33.33,0,0,1,270.67,236Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "280.828px 230.327px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M271.6,238.6a.37.37,0,0,1-.17-.7l20.32-10.61a.37.37,0,0,1,.5.16.36.36,0,0,1-.15.5l-20.33,10.61A.33.33,0,0,1,271.6,238.6Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "281.762px 232.924px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m318.07 217.43c-6.9 0.6-12.45 5.62-16 12.47-5.29 10.3-13.87 23.69-15.24 26-1.91 3.22-2.27 8.12-0.62 11.07 1.53 2.77 6.4 4 11.93-2.21 6.56-7.42 18.78-25.53 18.78-25.53s8.84-10.23 1.15-21.8z",
    fill: "#ffa8a7",
    style: {
      transformOrigin: "303.187px 243.336px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M263.11,225.13V225a16.42,16.42,0,0,1,.08-3.64,3.21,3.21,0,0,1,1.37-2.31,1.2,1.2,0,0,1,1.56.14,2.49,2.49,0,0,1,.28,1.24,9.41,9.41,0,0,0,.4,2.23,14.23,14.23,0,0,0,.88,1.85,8.85,8.85,0,0,1,.66,2.52c.1.81.17,1.61.3,2.4.24,1.52.33,3.17,1.24,4.48,1.37,2,18.23,16.71,18.23,16.71l1,18.49c-5.28-.64-17.48-15.51-21.6-20.54-4.51-5.51-6.91-8.2-9.57-11.27s-3.53-7.63-3.72-10.5c-.23-3.41.38-5.15,1.11-8.49,0-2.38,0-3.9,1.66-4.91l2.69,7.34,1.74,4.78c.33.3.53.58,1,.61a.9.9,0,0,0,.37-.06C263.09,225.9,263.13,225.5,263.11,225.13Z",
    fill: "#ffa8a7",
    style: {
      transformOrigin: "271.64px 241.255px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m318.5 216.24c-10.79 2.87-10.77 4.24-14.66 9.29s-15.71 23.47-15.71 23.47l-13.47-10.4s-7.08 1.45-8.1 8.83c0 0 9 12.39 13.94 17.16 3.94 3.8 8.22 6.37 11.6 5.13s5.58-3.28 13.84-12.6c5.66-6.39 9.33-10.55 12.87-15.06s8.99-21.22-0.31-25.82z",
    fill: "#263238",
    style: {
      transformOrigin: "295.104px 243.137px"
    }
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResult);
export default __webpack_public_path__ + "static/media/result.62676be7ac6cea7e484f6f3738ad545f.svg";
export { ForwardRef as ReactComponent };